<div class="animated fadeInDown DocumentContainer" *ngIf="showReceptionVisualizer">

  <div class="PopUpTitleContainer">
    <p class="SectionTitle" style="margin-top: 0%;" *ngIf="this.CurrentReception.ID == null && !DocumentBodyLoading;">
      <span *ngIf="!IsStorno;">{{ 'Receptions.NewReception' | translate }}</span>
      <span *ngIf="IsStorno;">{{ 'Receptions.StornoReception' | translate }}</span>
      </p>
      <p class="SectionTitle" style="margin-top: 0%;" *ngIf="this.CurrentReception.ID != null && !DocumentBodyLoading;">
        <span>
          {{CurrentReception.AccountingNumber.AccountingSeries.Series}} 
          {{(CurrentReception.AccountingNumber.Number)}} 
          / {{CurrentReception.EventRegisterUI}}
        </span>
      </p>
   </div> 

   <div class="PopUpCommands" style="margin-left: 2.5%;box-shadow: 0 4px 3px -2px rgb(0 0 0 / 30%);width: 95%;">
    <button class="ModernButton ModernButtonPrimary" (click)="ExportReception(this.CurrentReception);">
      <i class="material-icons">file_copy</i>
      <span>{{ 'Receptions.Document.Export' | translate }}</span>
    </button>

    <button mat-raised-button class="VizualizeCommandButton" (click)="PrintReception(this.CurrentReception);" style="outline: none;">
      <i class="material-icons">print</i>
      <span>{{ 'Receptions.Document.Print' | translate }}</span>
    </button>

    <button mat-raised-button class="VizualizeCommandButton" (click)="DownloadFile(this.CurrentReception);" style="outline: none;" *ngIf="CurrentReception.FilePath != null">
      <i class="material-icons">cloud_download</i>
      <span>{{ 'DownloadFile' | translate }}</span>
    </button>

    <button mat-raised-button color="primary" class="BackCommandButton" style="outline: none;float: right; background: #32aa3a;" (click)="this.parent.RedirectToURL('dashboard/documents/receptions');">
      <i class="material-icons">keyboard_double_arrow_left</i>
      <span>{{ 'Receptions.BackToReceptionsMenu' | translate }}</span>
    </button>

    <button [disabled]="this.DocumentBodyLoading || this.parent.loading" (click)="AutoPrintDocument(CurrentReception);" mat-raised-button class="VizualizeCommandButton" matTooltip="{{ 'AutoPrintDesc' | translate }}" matTooltipClass='neutral-tool-tip' style="outline: none;float: right;">
      <i class="material-icons">print</i>
      <span>{{ 'AutoPrint' | translate }}</span>
    </button>

    <mat-progress-bar mode="query" class="DocumentProgressBar" *ngIf="DocumentBodyLoading"></mat-progress-bar>
  </div>

   <div class="PopUpBody" style="max-height: 75vh;" *ngIf="!CurrentReception.IsStorno">
     <div class="DocumentBody">

      <p class="DocumentBodyCanceled" *ngIf="CurrentReception.DocumentStatus.ID == -1;">anulata</p>

       <div style="border: solid 1px #333;">
        
        <table style="width: 100%;margin-bottom: 20px;border-bottom: solid 1px #333;margin-top: 20px;">
          <tbody>
            <tr style="width: 100%;font-weight: 600;font-size: 16px;text-align: center;">
              <td>{{ 'Receptions.Document.Title' | translate }}</td>
            </tr>

            <table style="width: 100%;margin-top: 25px;">
              <tbody>
                <tr style="width: 70%;text-align: left;float: left;padding-left: 20px;">
                  <td>{{ 'Receptions.Document.Unity' | translate }}: {{this.parent.Company.Name}}</td>
                </tr>
                <tr style="width: 30%;text-align: left;float: left;">
                  <td>{{ 'Receptions.Document.DocNr' | translate }}:  {{CurrentReception.AccountingNumber.AccountingSeries.Series}}{{(CurrentReception.AccountingNumber.Number)}}</td>
                </tr>
              </tbody>
            </table>

            <table style="width: 100%;margin-top: 5px;">
              <tbody>
                <tr style="width: 70%;text-align: left;float: left;padding-left: 20px;margin-bottom: 20px;">
                  <td>{{ 'Receptions.Document.Administrations' | translate }}: 
                    <span *ngFor="let a of this.CurrentReception.Administrations; let i=index;">{{a.Name}}; </span>
                  </td>
                </tr>
                <tr style="width: 30%;text-align: left;float: left;">
                  <td>{{ 'Receptions.Document.Date' | translate }}: {{CurrentReception.EventRegisterUI}}</td>
                </tr>
              </tbody>
            </table>
           
          </tbody>
        </table>

        <table style="width: 100%;border-bottom: solid 1px #333;">
          <tbody>
            <table style="width: 100%;margin-top: 5px;">
              <tbody>
                <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                  <td>
                    {{ 'Receptions.Document.UndersignedTitle' | translate }} {{this.CurrentReception.Supplier.Name}}
                  </td>
                </tr>
              </tbody>
            </table>

            <table style="width: 100%;margin-top: 5px;">
              <tbody>
                <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                  <td>
                    {{ 'Receptions.Document.SupplyingDocuments' | translate }}: {{this.CurrentReception.DocumentNumber}}
                  </td>
                </tr>
              </tbody>
            </table>

            <table style="width: 100%;margin-top: 5px;">
              <tbody>
                <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                  <td>
                    {{ 'Receptions.Document.Delegate' | translate }}: {{this.CurrentReception.Details.Delegate}}
                  </td>
                </tr>
              </tbody>
            </table>

            <table style="width: 100%;margin-top: 5px;">
              <tbody>
                <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                  <td>
                    {{ 'Receptions.Document.Observations' | translate }}: {{this.CurrentReception.Details.Observations}}
                  </td>
                </tr>
              </tbody>
            </table>
            
            <table style="width: 100%;margin-top: 5px;margin-bottom: 20px;">
              <tbody>
                <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                  <td>
                    {{ 'Receptions.Document.Auto' | translate }}: {{this.CurrentReception.Details.Auto}}
                  </td>
                </tr>
              </tbody>
            </table>

          </tbody>
        </table>

        <table style="width: 100%;">
          <tbody>
            
            <table style="width: 100%;font-size: 12px;">
              <tbody>
                <tr style="width: 100%;">

                  <td style="width: 50%;float: left;padding: 0;">
                    <table style="width: 100%;">
                    <tbody>
                      <tr>
                        <td style="height: 70px;text-align: center;width: 10%;padding: 0;">{{ 'Receptions.Document.Table.Nr' | translate }}</td>
                        <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 60%;padding: 0;">{{ 'Receptions.Document.Table.Name' | translate }}</td>
                        <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 10%;padding: 0;">{{ 'Receptions.Document.Table.MU' | translate }}</td>
                        <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 20%;padding-left: 10px;padding-right: 10px;padding: 5;">{{ 'Receptions.Document.Table.DocQuantity' | translate }}</td>
                      </tr>
                    </tbody>
                    </table>
                  </td>

                  <td style="width: 50%;float: left;padding: 0;">
                    <table style="width: 100%;">
                    <tbody>

                      <tr>
                      <td style="padding: 0;">
                        <table style="width: 100%;height: 35px;border-bottom: solid 1px #333;">
                          <tbody>
                            <tr>
                              <td style="width: 100%;text-align: center;padding: 0;border-left: solid 1px #333;">{{ 'Receptions.Document.Table.Received' | translate }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      </tr>

                      <tr>
                        <td style="padding: 0;">
                          <table style="width: 100%;height: 35px;padding: 0;">
                            <tbody>
                              <tr>
                                <td style="text-align: center;width: 15%;padding: 0;">{{ 'Receptions.Document.Table.Quantity' | translate }}</td>
                                <td style="text-align: center;width: 30%;padding: 0;">{{ 'Receptions.Document.Table.UnitPrice' | translate }} ({{CurrentReception.Currency.Name}})</td>
                                <td style="text-align: center;width: 30%;padding: 0;">{{ 'Receptions.Document.Table.TotalValue' | translate }} ({{CurrentReception.Currency.Name}})</td>
                                <td style="text-align: center;width: 25%;padding: 0;">{{ 'Receptions.Document.Table.VATValue' | translate }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        </tr>

                    </tbody>
                    </table>
                  </td>

                </tr>

                <tr style="width: 100%;">

                 <td style="padding: 0;">
                  <table style="width: 100%;">
                    <tbody>
                      <tr style="width: 100%;height: 20px;line-height: 20px;border-top: solid 1px #ddd;" *ngFor="let p of this.CurrentReception.Products; let i=index;">
                        <td style="width: 5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{i + 1}}
                        </td>
            
                        <td style="width: 30%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          ({{p.ProductReceptionInfo.Code}}) {{p.ProductReceptionInfo.Name}}
                        </td>
            
                        <td style="width: 5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.MeasuringUnit.Name}}
                        </td>
            
                        <td style="width: 10%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.DocQuantity}}
                        </td>
            
                        <td style="width: 7.5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.Quantity}}
                        </td>
            
                        <td style="width: 15%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.Price.UIUnitPrice}}
                        </td>
            
                        <td style="width: 15%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.Price.UIQtyPrice}}
                        </td>
            
                        <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                          {{p.ProductReceptionInfo.Price.TotalVATValue}}
                        </td>
                      </tr>
                    </tbody>
                    </table>
                 </td>

                </tr>

                <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;">
                          
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                          
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                          {{ 'VATPercentages' | translate }}:
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                          {{ 'Receptions.Document.Table.TotalNOVAT' | translate }}:
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                          {{ 'Receptions.Document.Table.VATValue' | translate }}:
                         </td>
             
                         <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                          {{ 'Receptions.Document.Table.Total' | translate }}:
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                          <span *ngFor="let vat of CurrentReception.VATs">{{vat?.Percentage}}%; </span>
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;font-weight: bold;">
                          {{CurrentReception.Total.TotalQtyPriceNOVAT}} {{CurrentReception.Currency.Name}}
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;font-weight: bold;">
                          {{CurrentReception.Total.TotalVAT}} {{CurrentReception.Currency.Name}}
                         </td>
             
                         <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;font-weight: bold;">
                          {{CurrentReception.Total.TotalQtyPriceVAT}} {{CurrentReception.Currency.Name}}
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 40%;height: 20px;text-align: left;padding: 0;padding-left: 5px;border-right: solid 1px #333;">
                          {{ 'Receptions.Document.ReceptionCommitee' | translate }}: {{CurrentReception.Details.ReceptionCommittee}}
                         </td>
             
                         <td style="width: 60%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.ReceivedInAdministration' | translate }}:
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 35%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.FullName' | translate }}:
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: left;padding: 0;padding-right: 5px;">
                          {{ 'Receptions.Document.Signature' | translate }}
                         </td>
             
                         <td style="width: 32.5%;height: 20px;text-align: left;padding: 0;padding-left: 5px;border-left: solid 1px #333;">
                          {{ 'Receptions.Document.FullName' | translate }}:
                         </td>
             
                         <td style="width: 27.5%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.Signature' | translate }}
                         </td>
                        
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 40%;height: 50px;text-align: left;padding: 0;padding-left: 5px;">
                           
                         </td>
             
                         <td style="width: 60%;height: 50px;text-align: left;padding: 0;padding-left: 5px;border-left: solid 1px #333;">
                          {{CurrentReception.UpdatingUser.UserName}}
                         </td>
                        
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 40%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.Currency' | translate }}: {{CurrentReception.Details.CurrencyRow}}
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

              </tbody>
            </table>

          </tbody>
        </table>

       </div>

     </div>
   </div>

   <div class="PopUpBody" style="max-height: 75vh;" *ngIf="CurrentReception.IsStorno">
    <div class="DocumentBody">

     <p class="DocumentBodyCanceled" *ngIf="CurrentReception.DocumentStatus.ID == -1;">anulata</p>

      <div style="border: solid 1px #333;">
        <table style="width: 100%;margin-bottom: 20px;border-bottom: solid 1px #333;margin-top: 20px;">
          <tbody>
            <tr style="width: 100%;font-weight: 600;font-size: 16px;text-align: center;">
              <td>{{ 'Receptions.Document.DocumentStorno.ReturnTitle' | translate }}</td>
            </tr>

            <table style="width: 100%;margin-top: 25px;">
              <tbody>
                <tr style="width: 70%;text-align: left;float: left;padding-left: 20px;">
                  <td>{{ 'Receptions.Document.Unity' | translate }}: {{this.parent.Company.Name}}</td>
                </tr>
                <tr style="width: 30%;text-align: left;float: left;">
                  <td>{{ 'Receptions.Document.DocNr' | translate }}:  {{CurrentReception.AccountingNumber.AccountingSeries.Series}}{{(CurrentReception.AccountingNumber.Number)}}</td>
                </tr>
              </tbody>
            </table>

            <table style="width: 100%;margin-top: 5px;">
              <tbody>
                <tr style="width: 70%;text-align: left;float: left;padding-left: 20px;margin-bottom: 20px;">
                  <td>{{ 'Receptions.Document.Administrations' | translate }}: 
                    <span *ngFor="let a of this.CurrentReception.Administrations; let i=index;">{{a.Name}}; </span>
                  </td>
                </tr>
                <tr style="width: 30%;text-align: left;float: left;">
                  <td>{{ 'Receptions.Document.Date' | translate }}: {{CurrentReception.EventRegisterUI}}</td>
                </tr>
              </tbody>
            </table>
           
          </tbody>
        </table>

        <table style="width: 100%;border-bottom: solid 1px #333;">

          <tbody>
            <table style="width: 100%;margin-top: 5px;margin-bottom: 25px;">
              <tbody>
                <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                  <td>
                    {{ 'Receptions.Document.DocumentStorno.ReturnSubTitle' | translate }} {{this.CurrentReception.Supplier.Name}} 
                    {{ 'Receptions.Document.DocumentStorno.OnDocumentBasis' | translate }} {{CurrentReception.DocumentNumber}} / {{CurrentReception.DocumentDate}}
                  </td>
                </tr>
              </tbody>
            </table>
          </tbody>

        </table>

        <table style="width: 100%;">
          <tbody>
            
            <table style="width: 100%;font-size: 12px;">
              <tbody>
                <tr style="width: 100%;">

                  <td style="width: 50%;float: left;padding: 0;">
                    <table style="width: 100%;">
                    <tbody>
                      <tr>
                        <td style="height: 70px;text-align: center;width: 10%;padding: 0;">{{ 'Receptions.Document.Table.Nr' | translate }}</td>
                        <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 60%;padding: 0;">{{ 'Receptions.Document.Table.Name' | translate }}</td>
                        <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 10%;padding: 0;">{{ 'Receptions.Document.Table.MU' | translate }}</td>
                        <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 20%;padding-left: 10px;padding-right: 10px;padding: 5;">{{ 'Receptions.Document.Table.DocQuantity' | translate }}</td>
                      </tr>
                    </tbody>
                    </table>
                  </td>

                  <td style="width: 50%;float: left;padding: 0;">
                    <table style="width: 100%;">
                    <tbody>

                      <tr>
                      <td style="padding: 0;">
                        <table style="width: 100%;height: 35px;border-bottom: solid 1px #333;">
                          <tbody>
                            <tr>
                              <td style="width: 100%;text-align: center;padding: 0;border-left: solid 1px #333;">{{ 'Receptions.Document.Table.Returned' | translate }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      </tr>

                      <tr>
                        <td style="padding: 0;">
                          <table style="width: 100%;height: 35px;padding: 0;">
                            <tbody>
                              <tr>
                                <td style="text-align: center;width: 15%;padding: 0;">{{ 'Receptions.Document.Table.Quantity' | translate }}</td>
                                <td style="text-align: center;width: 30%;padding: 0;">{{ 'Receptions.Document.Table.UnitPrice' | translate }} ({{CurrentReception.Currency.Name}})</td>
                                <td style="text-align: center;width: 30%;padding: 0;">{{ 'Receptions.Document.Table.TotalValue' | translate }} ({{CurrentReception.Currency.Name}})</td>
                                <td style="text-align: center;width: 25%;padding: 0;">{{ 'Receptions.Document.Table.VATValue' | translate }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        </tr>

                    </tbody>
                    </table>
                  </td>

                </tr>

                <tr style="width: 100%;">

                 <td style="padding: 0;">
                  <table style="width: 100%;">
                    <tbody>
                      <tr style="width: 100%;height: 20px;line-height: 20px;border-top: solid 1px #ddd;" *ngFor="let p of this.CurrentReception.Products; let i=index;">
                        <td style="width: 5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{i + 1}}
                        </td>
            
                        <td style="width: 30%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          ({{p.ProductReceptionInfo.Code}}) {{p.ProductReceptionInfo.Name}}
                        </td>
            
                        <td style="width: 5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.MeasuringUnit.Name}}
                        </td>
            
                        <td style="width: 10%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.DocQuantity}}
                        </td>
            
                        <td style="width: 7.5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.Quantity}}
                        </td>
            
                        <td style="width: 15%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.Price.UIUnitPrice}}
                        </td>
            
                        <td style="width: 15%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.Price.UIQtyPrice}}
                        </td>
            
                        <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                          {{p.ProductReceptionInfo.TotalVATValue}}
                        </td>
                      </tr>
                    </tbody>
                    </table>
                 </td>

                </tr>

                <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;">
                          
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                          
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                          {{ 'Receptions.Document.Table.TotalNOVAT' | translate }}:
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                          {{ 'Receptions.Document.Table.VATValue' | translate }}:
                         </td>
             
                         <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                          {{ 'Receptions.Document.Table.Total' | translate }}:
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;font-weight: bold;">
                          {{CurrentReception.Total.TotalQtyPriceNOVAT}} {{CurrentReception.Currency.Name}}
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;font-weight: bold;">
                          {{CurrentReception.Total.TotalVAT}} {{CurrentReception.Currency.Name}}
                         </td>
             
                         <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;font-weight: bold;">
                          {{CurrentReception.Total.TotalQtyPriceVAT}} {{CurrentReception.Currency.Name}}
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 40%;height: 20px;text-align: left;padding: 0;padding-left: 5px;border-right: solid 1px #333;">
                          {{ 'Receptions.Document.ReceptionCommitee' | translate }}: {{CurrentReception.Details.ReceptionCommittee}}
                         </td>
             
                         <td style="width: 60%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.ReceivedInAdministration' | translate }}:
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 35%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.FullName' | translate }}:
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: left;padding: 0;padding-right: 5px;">
                          {{ 'Receptions.Document.Signature' | translate }}
                         </td>
             
                         <td style="width: 32.5%;height: 20px;text-align: left;padding: 0;padding-left: 5px;border-left: solid 1px #333;">
                          {{ 'Receptions.Document.FullName' | translate }}:
                         </td>
             
                         <td style="width: 27.5%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.Signature' | translate }}
                         </td>
                        
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 40%;height: 50px;text-align: left;padding: 0;padding-left: 5px;">
                           
                         </td>
             
                         <td style="width: 60%;height: 50px;text-align: left;padding: 0;padding-left: 5px;border-left: solid 1px #333;">
                          {{CurrentReception.UpdatingUser.UserName}}
                         </td>
                        
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 40%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.Currency' | translate }}: {{CurrentReception.Details.CurrencyRow}}
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

              </tbody>
            </table>

          </tbody>
        </table>
      </div>

    </div>
  </div>
</div>

<div class="MainContainer animated fadeIn">



    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowNoDocumentNumberError">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowNoDocumentNumberError = false;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'ShowNoDocumentNumberErrorTitle' | translate }}
      </div>
      <div class="InfoQuestionBody">
        <p>{{ 'ShowNoDocumentNumberErrorDescription' | translate }}</p>

        <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
          <mat-label>{{ 'Receptions.DocNumber' | translate }}*</mat-label>
          <input style="letter-spacing: 1px; color: #f60; font-weight: 500!important;" matInput placeholder="Doc Number*" autocomplete="off" [(ngModel)]="CurrentReception.DocumentNumber" (change)="MatchUnallocatedUIT(this.partner, CurrentReception.DocumentNumber); GetDocumentDupplication(this.partner, CurrentReception.DocumentNumber, CurrentReception.ID);CheckUnAllocatedPaymentsByDocumentNumber(CurrentReception.DocumentNumber); MatchUnallocatedUIT(this.partner, CurrentReception.DocumentNumber);">
        </mat-form-field>
      </div>
    
      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowNoDocumentNumberError = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button *ngIf="CurrentReception.ID == null;" [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowNoDocumentNumberError = false; ForceReception = true; AddReception();">{{ 'Receptions.SaveReception' | translate }}</button>
        <button *ngIf="CurrentReception.ID != null;" [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowNoDocumentNumberError = false; ForceReception = true; UpdateReception();">{{ 'Receptions.SaveReception' | translate }}</button>
      </div>
    </div>










    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteSpendingQuestion">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowDeleteSpendingQuestion = false; currentSpending = null;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'Configuration.DeleteQuestion' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'Configuration.DeleteQuestionDescription' | translate }}
      </div>

      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteSpendingQuestion = false; currentPayment = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteSpendingQuestion = false;DeletePayment(currentPayment.ID);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
      </div>
    </div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="DeleteFileQuestion">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="DeleteFileQuestion = false;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'Configuration.DeleteQuestion' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'Configuration.DeleteQuestionDescription' | translate }}
      </div>

      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="DeleteFileQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="DeleteFileQuestion = false;DeleteFile(this.CurrentReception.ID);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
      </div>
    </div>

      <div class="MainTitleBar" *ngIf="this.CurrentReception.Details?.ForceDocumentClosing == true && this.CurrentReception.Status?.ID == 1;">
        <div class="TopValueBanner"  [ngClass]="{'CollectedStatusPopUp': this.CurrentReception.Status.ID == 1}">
          <div>
            {{CurrentReception.Status.Name}} {{'ForcedDocumentClose' | translate}} 
            <i class="material-icons TopValueBannerIcon">verified</i>
          </div>
        </div>
      </div>

      <div class="MainTitleBar" *ngIf="this.CurrentReception.Details?.PaymentRemainingValue != undefined;">
        <div class="TopValueBanner"  [ngClass]="{'CollectedStatusPopUp': this.CurrentReception.Details?.PaymentRemainingValue == 0, 'OverduePopUp': this.CurrentReception.Details?.PaymentRemainingValue != 0 && this.CurrentReception.Status?.ID == 5}">

          <div *ngIf="this.CurrentReception.Details?.PaymentRemainingValue != 0;">
            {{'RemainingToBePaid' | translate}}:
            <span class="TopValueBannerValue">{{this.CurrentReception.Details?.PaymentRemainingValue}} {{currency.Name}}</span>
            <i *ngIf="this.CurrentReception.Status?.ID == 5;" class="material-icons TopValueBannerIcon">money_off_csred</i>
          </div>

          <div *ngIf="this.CurrentReception.Details?.PaymentRemainingValue == 0;">
            {{CurrentReception.Status?.Name}}
            <i class="material-icons TopValueBannerIcon">verified</i>
          </div>

        </div>
      </div>

      <div class="MainTitleBar" *ngIf="this.CurrentReception.ID?.length > 0;">

        <div class="TopValueBanner" style="background: #efdc75;opacity: 0.75;">
          <span style="color: #f60;">{{'ClosedDocumentModificationWarning' | translate}}</span>
          <i class="material-icons TopValueBannerIcon" style="color: #f60;">lightbulb</i>
        </div>
      </div>

    <div class="MainTitleBar" *ngIf="SavedReception != true;">
        <p class="SectionTitle" style="margin-top: 0%;border-bottom: solid 1px #ddd;" *ngIf="this.CurrentReception.ID == null;">
        <span *ngIf="!IsStorno;">{{ 'Receptions.NewReception' | translate }}</span>
        <span *ngIf="IsStorno;">{{ 'Receptions.StornoReception' | translate }}</span>
        <span class="DocumentMainCurrencyTopValue" *ngIf="currency">{{currency.Name}}</span>
        </p>
        <p class="SectionTitle" style="margin-top: 0%;" *ngIf="this.CurrentReception.ID != null;">
          <span *ngIf="!IsStorno">
            {{ 'Receptions.UpdateReception' | translate }}
          </span>
          <span *ngIf="IsStorno">
            {{ 'Receptions.ModifyStorno' | translate }}
          </span>
          <span class="InvoiceDisplayValue">{{this.CurrentReception.AccountingNumber.DisplayValue}}</span>
          <span class="DocumentMainCurrencyTopValue" *ngIf="currency">{{currency.Name}}</span>
        </p>
    </div>

    <div class="MainBody animated fadeIn" *ngIf="this.parent.initialLoad == false && SavedReception != true;">
       
        <div class="NewReceptionBodyRow">
            <div class="PartnerSearchContainer">
                <p class="NewTextBoxContainerTitle">{{ 'Receptions.SearchSupplier' | translate }}*</p>

                <!-- Partner Search Bar (1-on-1 from management/quotations/new) -->
                <div class="PartnerSearchBar">
                  <i class="material-icons search-icon" *ngIf="!this.searchTerm || this.searchTerm.length === 0">search</i>
                  <i class="material-icons clear-icon" *ngIf="this.searchTerm?.length > 0" (click)="this.searchTerm=''; this.Partners.length = 0; resultsLength = 0;">close</i>
                  <input
                    type="text"
                    class="PartnerSearchInput"
                    placeholder="Name/VAT"
                    [(ngModel)]="this.searchTerm"
                    (focus)="InitializePartnersOnClick(this.searchTerm, this.countryID, true);"
                    (ngModelChange)="this.searchPartnerUpdate.next($event)"
                    (keydown.enter)="this.partner = Partners[0];resultsLength = 0;this.searchTerm='';AdjustCurrencyOnPartnerSeleciton();GetDocumentDupplication(this.partner, CurrentReception.DocumentNumber, CurrentReception.ID);TestDocumentValidity(); MatchUnallocatedUIT(this.partner, CurrentReception.DocumentNumber);"
                  />
                  <i class="material-icons person-add-icon" *ngIf="!this.searchTerm" (click)="showAddNewPartnerPopUp = true;initializeAddPartnerForm();">person_add</i>
                  <mat-spinner class="search-spinner" *ngIf="parent.loading" [diameter]="20"></mat-spinner>
                </div>

                <!-- Search Results Dropdown (1-on-1 from management/quotations/new) -->
                <div class="PartnerSearchResults" *ngIf="resultsLength > 0">
                  <div class="PartnerSearchResult" *ngFor="let p of Partners" (click)="this.partner = p;resultsLength = 0;this.searchTerm='';AdjustCurrencyOnPartnerSeleciton();GetDocumentDupplication(this.partner, CurrentReception.DocumentNumber, CurrentReception.ID);TestDocumentValidity(); MatchUnallocatedUIT(this.partner, CurrentReception.DocumentNumber);">
                    <div class="PartnerResultMain">
                      <span class="PartnerName">{{p.Name}}</span>
                      <span class="PartnerVAT" *ngIf="p.VAT?.length">{{p.VAT}}</span>
                    </div>
                  </div>
                </div>

                <!-- Selected Partner Display -->
                <div class="PartnerInfoContainer" *ngIf="partner != null">
                  <i class="material-icons PartnerInfoContainerEUVerified" matTooltip="EU Verified" *ngIf="partner.EUVATVerified">verified_user</i>
                  <p class="PartnerInfoTitle">{{partner.Name }}
                      <i *ngIf="partner.ID != null;" class="material-icons PartnerDeleteIcon" (click)="partner = null;TestDocumentValidity();">close</i>
                      <i *ngIf="partner.ID != null;" class="material-icons PartnerEditIcon" (click)="initializePartnerFormFromObject(partner);">edit</i>
                      <i *ngIf="partner.ID == null;" class="material-icons PartnerEditIcon" (click)="InsertPartnerFromCloud(partner);">cloud_download</i>
                  </p>
                  <span class="PartnerInfoSubTitle" *ngIf="partner.VAT?.length;">{{partner.VAT}} | </span>
                  <span class="PartnerInfoSubTitle" *ngIf="partner.COCRegNumber?.length;">{{partner.COCRegNumber}}</span>
                  <p class="PartnerInfoSubTitle">{{partner.BillingAddress.Country.ShortName}}, {{partner.BillingAddress.StateProvince}}, {{partner.BillingAddress.City}},| {{partner.BillingAddress.AddressLine}}</p>
                </div>
            </div>
    
            <div class="newReceptionInputContainer" style="width: 15%;">
                <p class="NewTextBoxContainerTitle">{{ 'Receptions.DocumentType' | translate }}</p>
                <div class="CustomDropdownContainer">
                  <div class="DropdownOverlayTransparent" *ngIf="showDocTypeDropdown" (click)="showDocTypeDropdown = false"></div>
                  <div class="CustomDropdownBar" [class.open]="showDocTypeDropdown" (click)="showDocTypeDropdown = !showDocTypeDropdown">
                    <span class="dropdown-label">{{ 'Receptions.DocumentType' | translate }}</span>
                    <i class="material-icons dropdown-icon-left">description</i>
                    <input type="text" class="CustomDropdownInput" [class.placeholder]="!CurrentReception.DocType?.Meaning" [value]="CurrentReception.DocType?.Meaning || ('Receptions.DocumentType' | translate)" readonly />
                    <i class="material-icons dropdown-icon">arrow_drop_down</i>
                  </div>
                  <div class="CustomDropdownResults" *ngIf="showDocTypeDropdown">
                    <div class="CustomDropdownResult" *ngFor="let doc of this.DocTypes" [class.selected]="compareFn(CurrentReception.DocType, doc)" (click)="CurrentReception.DocType = doc; showDocTypeDropdown = false;">
                      <div class="CustomDropdownResultMain">
                        <span class="CustomDropdownResultText">{{doc.Meaning}}</span>
                      </div>
                      <i class="material-icons CustomDropdownResultCheck" *ngIf="compareFn(CurrentReception.DocType, doc)">check</i>
                    </div>
                  </div>
                </div>

                <p class="NewTextBoxContainerTitle" *ngIf="CurrentReception.AccountingNumber.ID == null;">{{ 'Receptions.Series' | translate }}</p>
                <div class="CustomDropdownContainer" *ngIf="CurrentReception.AccountingNumber.ID == null;">
                  <div class="DropdownOverlayTransparent" *ngIf="showSeriesDropdown" (click)="showSeriesDropdown = false"></div>
                  <div class="CustomDropdownBar" [class.open]="showSeriesDropdown" (click)="showSeriesDropdown = !showSeriesDropdown">
                    <span class="dropdown-label">{{ 'Receptions.Series' | translate }}</span>
                    <i class="material-icons dropdown-icon-left">format_list_numbered</i>
                    <input type="text" class="CustomDropdownInput" [class.placeholder]="!CurrentReception.AccountingNumber.AccountingSeries?.Series" [value]="CurrentReception.AccountingNumber.AccountingSeries?.Series ? (CurrentReception.AccountingNumber.AccountingSeries.Series + ' (nr.XXXX)') : ('Receptions.Series' | translate)" readonly />
                    <i class="material-icons dropdown-icon">arrow_drop_down</i>
                  </div>
                  <div class="CustomDropdownResults" *ngIf="showSeriesDropdown">
                    <div class="CustomDropdownResult" *ngFor="let series of this.AccountingSeries" [class.selected]="compareFn(CurrentReception.AccountingNumber.AccountingSeries, series)" (click)="CurrentReception.AccountingNumber.AccountingSeries = series; showSeriesDropdown = false;">
                      <div class="CustomDropdownResultMain">
                        <span class="CustomDropdownResultText">{{series.Series}} (nr.XXXX)</span>
                      </div>
                      <i class="material-icons CustomDropdownResultCheck" *ngIf="compareFn(CurrentReception.AccountingNumber.AccountingSeries, series)">check</i>
                    </div>
                  </div>
                </div>

                <p class="NewTextBoxContainerTitle" *ngIf="CurrentReception.AccountingNumber.ID != null;">{{ 'Receptions.Series' | translate }}</p>
                <div class="NewTextBoxContainer" style="width: 100%;" *ngIf="CurrentReception.AccountingNumber.ID != null;">
                    <input type="text" class="NewTextBox" placeholder="Series" autocomplete="off" disabled="true" [value]="CurrentReception.AccountingNumber.AccountingSeries.Series + ' ' + CurrentReception.AccountingNumber.Number">
                </div>
            </div>
    
            <div class="newReceptionInputContainer" style="width: 15%;">
                  <p class="NewTextBoxContainerTitle">{{ 'Receptions.DocNumber' | translate }}*</p>
                  <div class="NewTextBoxContainer" style="width: 100%;">
                    <input type="text" class="NewTextBox" style="letter-spacing: 1px; color: #f60; font-weight: 500!important;" placeholder="Doc Number*" autocomplete="off" [(ngModel)]="CurrentReception.DocumentNumber" (change)="GetDocumentDupplication(this.partner, CurrentReception.DocumentNumber, CurrentReception.ID);CheckUnAllocatedPaymentsByDocumentNumber(CurrentReception.DocumentNumber); MatchUnallocatedUIT(this.partner, CurrentReception.DocumentNumber);">
                    <i *ngIf="this.CurrentReception.Details.ETransportDetails?.ETransportUIT?.length" matTooltip="{{'FoundUITForGivenDocument' | translate}} {{this.CurrentReception.Details.ETransportDetails?.ETransportUIT}}" matTooltipClass='neutral-tool-tip' class="material-icons UITFoundIcon">verified</i>
                  </div>

                  <div class="DupplicateDocumentAlert" *ngFor="let dupplicate of this.DupplicateDocumentReceptions">
                      {{'DupplicateDocuments' | translate}}: 
                    <span>
                      {{dupplicate.AccountingNumber.DisplayValue}}
                    </span>
                  </div>

                  <div class="DupplicateDocumentAlert" *ngFor="let dupplicate of this.DupplicateDocumentReceptions">
                    {{'InvoiceCreator' | translate}}: 
                    <span>
                      {{dupplicate.CreatingUser.UIName}}
                    </span>
                  </div>

                  <div class="DupplicateDocumentAlert" *ngFor="let dupplicate of this.DupplicateDocumentReceptions">
                    {{'Receptions.DocumentDate' | translate}}: 
                    <span>
                      {{dupplicate.EventRegisterUI}}
                    </span>
                  </div>

                  <div class="DupplicateDocumentAlert" *ngIf="this.DetectedPayments?.length;" style="padding-left:0;">
                    <div class="DetectedPaymentsButton" (click)="OpenDetectedPayments();">
                      <i class="material-icons">notifications_active</i>
                      {{'DetectedPayments' | translate}} [{{this.DetectedPayments?.length}}]
                    </div>
                  </div>
            </div>
    
            <div class="newReceptionInputContainer">
                <p class="NewTextBoxContainerTitle">{{ 'Receptions.DocumentDate' | translate }}</p>
                <div class="NewTextBoxContainer" style="width: 100%;">
                    <input type="text" class="NewTextBox" [matDatepicker]="dp" [formControl]="DocumentDate" [(ngModel)]="CurrentReception.DocumentDate" (dateChange)="TestDocumentValidity();">
                    <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                    <mat-datepicker #dp></mat-datepicker>
                </div>

                <p class="NewTextBoxContainerTitle">{{ 'Receptions.DueDate' | translate }}</p>
                <div class="NewTextBoxContainer" style="width: 100%;">
                    <input type="text" class="NewTextBox" [matDatepicker]="dp1" [formControl]="PaymentDueDate" [(ngModel)]="CurrentReception.PaymentDueDate" (dateChange)="TestDocumentValidity();">
                    <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
                    <mat-datepicker #dp1></mat-datepicker>
                </div>
            </div>
    
            <div class="newReceptionInputContainer" style="width: 15%;">
                <p class="NewTextBoxContainerTitle">{{ 'Receptions.Currency' | translate }}</p>
                <div class="CustomDropdownContainer">
                  <div class="DropdownOverlayTransparent" *ngIf="showCurrencyDropdown" (click)="showCurrencyDropdown = false"></div>
                  <div class="CustomDropdownBar" [class.open]="showCurrencyDropdown" (click)="showCurrencyDropdown = !showCurrencyDropdown">
                    <span class="dropdown-label">{{ 'Receptions.Currency' | translate }}</span>
                    <i class="material-icons dropdown-icon-left">attach_money</i>
                    <input type="text" class="CustomDropdownInput" [class.placeholder]="!currency?.Name" [value]="currency?.Name || ('Receptions.Currency' | translate)" readonly />
                    <i class="material-icons dropdown-icon">arrow_drop_down</i>
                  </div>
                  <div class="CustomDropdownResults" *ngIf="showCurrencyDropdown">
                    <div class="CustomDropdownResult" *ngFor="let c of this.Currencies" [class.selected]="compareFn(currency, c)" (click)="currency = c; showCurrencyDropdown = false; GetCurrencyLiveExchange(currency);">
                      <div class="CustomDropdownResultMain">
                        <span class="CustomDropdownResultText">{{c.Name}}</span>
                      </div>
                      <i class="material-icons CustomDropdownResultCheck" *ngIf="compareFn(currency, c)">check</i>
                    </div>
                  </div>
                </div>

                <div class="ReceptionSelectedCurrency" *ngIf="currency != null && currency.ExchangeRate > 0;">
                    <p class="NewTextBoxContainerTitle">{{ 'Receptions.ExchangeRate' | translate }}</p>
                    <div class="NewTextBoxContainer" style="width: 100%;">
                        <input type="text" class="NewTextBox" [(ngModel)]="currency.ExchangeRate" placeholder="Exchange">
                        <i style="border: none;" class="material-icons PartnerEditIcon">edit</i>
                    </div>
                </div>
            </div>
        </div>

        <div class="NewReceptionBodyRow">
            <div class="PartnerSearchContainer">
                
            </div>
    
            <div class="newReceptionInputContainer" style="width: 15%;">
              
            </div>
    
            <div class="newReceptionInputContainer" style="width: 15%;">
             
            </div>
    
            <div class="newReceptionInputContainer">
                <p class="NewTextBoxContainerTitle">{{ 'Receptions.StockEntryDate' | translate }}</p>
                <div class="NewTextBoxContainer" style="width: 100%;">
                    <input type="text" class="NewTextBox" [matDatepicker]="dp2" [formControl]="StockEntryDate" [(ngModel)]="CurrentReception.StockEntryDate" (dateChange)="TestDocumentValidity();">
                    <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
                    <mat-datepicker #dp2></mat-datepicker>
                </div>
            </div>

            <div class="newReceptionInputContainer" style="width: 15%;">
                <p class="NewTextBoxContainerTitle">{{ 'Receptions.DecimalPercision' | translate }}</p>
                <div class="CustomDropdownContainer">
                  <div class="DropdownOverlayTransparent" *ngIf="showDecimalPrecisionDropdown" (click)="showDecimalPrecisionDropdown = false"></div>
                  <div class="CustomDropdownBar" [class.open]="showDecimalPrecisionDropdown" (click)="showDecimalPrecisionDropdown = !showDecimalPrecisionDropdown">
                    <span class="dropdown-label">{{ 'Receptions.DecimalPercision' | translate }}</span>
                    <i class="material-icons dropdown-icon-left">calculate</i>
                    <input type="text" class="CustomDropdownInput" [class.placeholder]="!ReceptionPrecision?.Meaning" [value]="ReceptionPrecision?.Meaning || ('Receptions.DecimalPercision' | translate)" readonly />
                    <i class="material-icons dropdown-icon">arrow_drop_down</i>
                  </div>
                  <div class="CustomDropdownResults" *ngIf="showDecimalPrecisionDropdown">
                    <div class="CustomDropdownResult" *ngFor="let p of this.DecimalPrecisions" [class.selected]="compareFn(ReceptionPrecision, p)" (click)="ReceptionPrecision = p; showDecimalPrecisionDropdown = false; AdjustProductsDecimalPrecisionPrice();">
                      <div class="CustomDropdownResultMain">
                        <span class="CustomDropdownResultText">{{p.Meaning}}</span>
                      </div>
                      <i class="material-icons CustomDropdownResultCheck" *ngIf="compareFn(ReceptionPrecision, p)">check</i>
                    </div>
                  </div>
                </div>
            </div>
        </div>

        <div class="NewReceptionBodyRow">
          <!-- 🍎 Modern File Upload Section -->
          <div class="FileUploadSection">
            <p class="NewTextBoxContainerTitle">{{ 'UploadDocument' | translate }}</p>

            <div class="FileUploadContainer">
              <!-- Hidden file input -->
              <input type="file"
                     #fileInput
                     (change)="onSelectFile($event)"
                     accept=".pdf,.jpg,.jpeg,.png,.xml"
                     style="display: none;">

              <!-- Upload Button -->
              <button class="ModernButton ModernButtonPrimary"
                      (click)="fileInput.click()"
                      *ngIf="!selectedFile">
                <i class="material-icons">upload_file</i>
                <span>{{ 'ChooseFile' | translate }}</span>
              </button>

              <!-- File Selected Display - Upload & Extract -->
              <div class="FileSelectedDisplay" *ngIf="selectedFile">
                <div class="FileInfo">
                  <i class="material-icons">description</i>
                  <span class="FileName">{{ selectedFile.name }}</span>
                  <span class="FileSize">({{ formatFileSize(selectedFile.size) }})</span>
                </div>
                <div class="FileActions">
                  <button class="ModernButton ModernButtonPrimary" (click)="UploadDocumentFile()">
                    <i class="material-icons">auto_awesome</i>
                    <span>{{ 'UploadAndExtract' | translate }}</span>
                  </button>
                  <button class="ModernButton ModernButtonPrimary" (click)="UploadReceptionFile()" *ngIf="CurrentReception.ID != null">
                    <i class="material-icons">upload_file</i>
                    <span>{{ 'UploadOnly' | translate }}</span>
                  </button>
                  <button class="ModernButton ModernButtonSecondary" (click)="clearSelectedFile()">
                    <i class="material-icons">close</i>
                    <span>{{ 'Cancel' | translate }}</span>
                  </button>
                </div>
              </div>

              <!-- 🍎 Download Uploaded File Button -->
              <button class="ModernButton ModernButtonPrimary"
                      *ngIf="CurrentReception.FilePath != null && !selectedFile"
                      (click)="DownloadFile(CurrentReception);">
                <i class="material-icons">cloud_download</i>
                <span>{{ 'DownloadFile' | translate }}</span>
              </button>

              <!-- 🍎 Green Import with Indexes Button -->
              <button class="ModernButton ModernButtonSuccess"
                      [disabled]="!partner || !currency || !ReceptionPrecision"
                      [title]="(!partner || !currency || !ReceptionPrecision) ? 'Please select Partner, Currency and Decimal Precision first' : ''"
                      (click)="ShowImportWithIndexesPopup = true;">
                <i class="material-icons">table_chart</i>
                <span>{{ 'ImportWithIndexes' | translate }}</span>
              </button>
            </div>
          </div>
        </div>

        <div class="ReceptionProductsContainer">
            <div class="ReceptionProductsRow ProductInputRow" style="padding-top: 10px;border: none;">
                <div class="ReceptionProductsCol" style="width: 15%;">
                    <p class="NewTextBoxContainerTitle">{{ 'Receptions.Administration' | translate }}</p>
                    <div class="CustomDropdownContainer" *ngIf="NewProduct.ID == null;">
                      <div class="DropdownOverlayTransparent" *ngIf="showAdministrationDropdown" (click)="showAdministrationDropdown = false"></div>
                      <div class="CustomDropdownBar" [class.open]="showAdministrationDropdown" (click)="showAdministrationDropdown = !showAdministrationDropdown">
                        <span class="dropdown-label">{{ 'Receptions.Administration' | translate }}</span>
                        <i class="material-icons dropdown-icon-left">business</i>
                        <input type="text" class="CustomDropdownInput" [class.placeholder]="!NewProduct.ProductReceptionInfo.Administration?.Name" [value]="NewProduct.ProductReceptionInfo.Administration?.Name || ('Receptions.Administration' | translate)" readonly />
                        <i class="material-icons dropdown-icon">arrow_drop_down</i>
                      </div>
                      <div class="CustomDropdownResults" *ngIf="showAdministrationDropdown">
                        <div class="CustomDropdownResult" *ngFor="let a of this.Administrations" [class.selected]="compareFirst(NewProduct.ProductReceptionInfo.Administration, a)" (click)="NewProduct.ProductReceptionInfo.Administration = a; showAdministrationDropdown = false; SearchProductsReceptionInformation(NewProduct.ProductReceptionInfo.Name, NewProduct.ProductReceptionInfo.Administration.ID, false);">
                          <div class="CustomDropdownResultMain">
                            <span class="CustomDropdownResultText">{{a.Name}}</span>
                          </div>
                          <i class="material-icons CustomDropdownResultCheck" *ngIf="compareFirst(NewProduct.ProductReceptionInfo.Administration, a)">check</i>
                        </div>
                      </div>
                    </div>

                    <div class="NewTextBoxContainer" style="width: 100%;" *ngIf="NewProduct.ID != null;">
                        <input type="text" class="NewTextBox" disabled="disabled" placeholder="{{ 'Receptions.Administration' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductReceptionInfo.Administration.Name">
                    </div>
                </div>
                <div class="ReceptionProductsCol" style="width: 20%;text-align: left;">
                    <p class="NewTextBoxContainerTitle">{{ 'Receptions.Table.Name' | translate }}</p>
                    <div class="NewTextBoxContainer" style="width: 100%;">
                        <input type="text" class="NewTextBox" (click)="SearchProductsReceptionInformation(NewProduct.ProductReceptionInfo.Name, NewProduct.ProductReceptionInfo.Administration.ID, false); showhideSearches(false);" placeholder="{{ 'Receptions.Table.Name' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductReceptionInfo.Name" (ngModelChange)="chanveNewProductVALUE($event); SearchProductsReceptionInformation(NewProduct.ProductReceptionInfo.Name, NewProduct.ProductReceptionInfo.Administration.ID, false);" (keydown.enter)="SelectReceptionProductFromSearch(ProductsSearchResults[0]);">
                        <i class="material-icons" style="cursor: pointer;" *ngIf="ProductsSearchResultsCOUNT == 0 && !loadingSearchProducts && NewProduct.ProductReceptionInfo.Name.length == 0;">search</i>
                        <i class="material-icons" style="cursor: pointer;" *ngIf="(ProductsSearchResultsCOUNT > 0 || NewProduct.ProductReceptionInfo.Name.length > 0) && !loadingSearchProducts;" (click)="DestroySearchedProducts();">close</i>
                    </div>
                    <div class="SpinnerIconContainer" *ngIf="loadingSearchProducts">
                        <mat-spinner class="smallSpinner" [diameter]="25"></mat-spinner>
                    </div>
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    <p class="NewTextBoxContainerTitle">{{ 'Receptions.Table.Code' | translate }}</p>
                    <div class="NewTextBoxContainer" style="width: 100%;">
                        <input type="text" class="NewTextBox" placeholder="{{ 'Receptions.Table.Code' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductReceptionInfo.Code" (ngModelChange)="chanveNewProductVALUE($event); SearchProductsReceptionInformation(NewProduct.ProductReceptionInfo.Code, NewProduct.ProductReceptionInfo.Administration.ID, false);">
                    </div>
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    <p class="NewTextBoxContainerTitle">{{ 'Receptions.Table.MU' | translate }}</p>
                    <div class="CustomDropdownContainer">
                      <div class="DropdownOverlayTransparent" *ngIf="showMeasuringUnitDropdown" (click)="showMeasuringUnitDropdown = false"></div>
                      <div class="CustomDropdownBar" [class.open]="showMeasuringUnitDropdown" (click)="showMeasuringUnitDropdown = !showMeasuringUnitDropdown">
                        <span class="dropdown-label">{{ 'Receptions.Table.MU' | translate }}</span>
                        <i class="material-icons dropdown-icon-left">straighten</i>
                        <input type="text" class="CustomDropdownInput" [class.placeholder]="!NewProduct.ProductReceptionInfo.MeasuringUnit?.Name" [value]="NewProduct.ProductReceptionInfo.MeasuringUnit?.Name || ('Receptions.Table.MU' | translate)" readonly />
                        <i class="material-icons dropdown-icon">arrow_drop_down</i>
                      </div>
                      <div class="CustomDropdownResults" *ngIf="showMeasuringUnitDropdown">
                        <div class="CustomDropdownResult" *ngFor="let u of this.MeasuringUnits" [class.selected]="compareFirst(NewProduct.ProductReceptionInfo.MeasuringUnit, u)" (click)="NewProduct.ProductReceptionInfo.MeasuringUnit = u; showMeasuringUnitDropdown = false; chanveNewProductVALUE($event);">
                          <div class="CustomDropdownResultMain">
                            <span class="CustomDropdownResultText">{{u.Name}}</span>
                          </div>
                          <i class="material-icons CustomDropdownResultCheck" *ngIf="compareFirst(NewProduct.ProductReceptionInfo.MeasuringUnit, u)">check</i>
                        </div>
                      </div>
                    </div>
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    <p class="NewTextBoxContainerTitle">{{ 'Receptions.Table.Qty' | translate }}</p>
                    <div class="NewTextBoxContainer" style="width: 100%;">
                        <input type="text" class="NewTextBox" placeholder="{{ 'Receptions.Table.Qty' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductReceptionInfo.Quantity" (ngModelChange)="chanveNewProductVALUE($event);MirrorDocQuantity($event);">
                    </div>
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    <p class="NewTextBoxContainerTitle">{{ 'Receptions.Table.DocQty' | translate }}</p>
                    <div class="NewTextBoxContainer" style="width: 100%;">
                        <input type="text" class="NewTextBox" placeholder="{{ 'Receptions.Table.DocQty' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductReceptionInfo.DocQuantity" (ngModelChange)="chanveNewProductVALUE($event);">
                    </div>
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                    <p class="NewTextBoxContainerTitle">{{ 'Receptions.Table.Price' | translate }}</p>
                    <div class="NewTextBoxContainer" style="width: 100%;" *ngIf="!NewProductPriceContainsVAT">
                        <input type="text" class="NewTextBox" placeholder="{{ 'Receptions.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductReceptionInfo.Price.UIUnitPrice" (ngModelChange)="chanveNewProductVALUE($event);" (change)="VerifyPriceModel(NewProduct.ProductReceptionInfo.Price.UIUnitPrice);">
                    </div>

                    <div class="NewTextBoxContainer" style="width: 100%;" *ngIf="NewProductPriceContainsVAT">
                        <input type="text" class="NewTextBox" placeholder="{{ 'Receptions.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductReceptionInfo.Price.UIVATUnitPrice" (ngModelChange)="chanveNewProductVALUE($event);" (change)="VerifyPriceModel(NewProduct.ProductReceptionInfo.Price.UIVATUnitPrice);">
                    </div>
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                  <p class="NewTextBoxContainerTitle">{{ 'Receptions.Table.VAT' | translate }}</p>
                  <div class="CustomDropdownContainer">
                    <div class="DropdownOverlayTransparent" *ngIf="showVATDropdown" (click)="showVATDropdown = false"></div>
                    <div class="CustomDropdownBar" [class.open]="showVATDropdown" (click)="showVATDropdown = !showVATDropdown">
                      <span class="dropdown-label">{{ 'Receptions.Table.VAT' | translate }}</span>
                      <i class="material-icons dropdown-icon-left">percent</i>
                      <input type="text" class="CustomDropdownInput" [class.placeholder]="!NewProduct.ProductReceptionInfo.Price.VAT?.Name" [value]="NewProduct.ProductReceptionInfo.Price.VAT?.Name || ('Receptions.Table.VAT' | translate)" readonly />
                      <i class="material-icons dropdown-icon">arrow_drop_down</i>
                    </div>
                    <div class="CustomDropdownResults" *ngIf="showVATDropdown">
                      <div class="CustomDropdownResult" *ngFor="let v of this.VATRates" [class.selected]="compareFirst(NewProduct.ProductReceptionInfo.Price.VAT, v)" (click)="NewProduct.ProductReceptionInfo.Price.VAT = v; showVATDropdown = false; chanveNewProductVALUE($event);">
                        <div class="CustomDropdownResultMain">
                          <span class="CustomDropdownResultText">{{v.Name}}</span>
                        </div>
                        <i class="material-icons CustomDropdownResultCheck" *ngIf="compareFirst(NewProduct.ProductReceptionInfo.Price.VAT, v)">check</i>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ReceptionProductsCol" style="width: 15%;">
                  <button [disabled]="!IsValidNewProduct" class="ModernButton ModernButtonPrimary" style="width: 100%;margin-top: 35px;" (click)="AddProductToReception();">
                    <i class="material-icons">add_circle</i>
                    <span>{{ 'Receptions.Table.AddToReception' | translate }}</span>
                </button>
                </div>

                <div class="ProductsSearchResultsContainer" *ngIf="ProductsSearchResultsCOUNT > 0 && this.showSearch;" style="margin-top:5px;">
                  <div class="ProductSearchResult" *ngFor="let p of ProductsSearchResults" (click)="SelectReceptionProductFromSearch(p);" [ngClass]="{'SearchResultPoolProductAlert': p.IsFromPool}">
                    <p class="ProductSearchResultTitle">{{p.Name}} 
                      <span *ngIf="p.DiscrepancyAmmount != null;" class="DiscrepancyAmmountSpan" [ngClass]="{'MinusDiscrepancyAmmount': p.DiscrepancyAmmount < 0, 'NormalDiscrepancyAmmount': p.DiscrepancyAmmount >= 0}">{{p.DiscrepancyAmmount}}
                        <span *ngIf="p.DiscrepancyAmmount < 0;"> {{'MissingStockValue' | translate}}</span>
                        <span *ngIf="p.DiscrepancyAmmount >= 0;"> {{'StockValue' | translate}}</span>
                      </span>
                    </p>
                    <p class="ProductSearchResultType">[{{p.Code}}] [{{p.GeneralType.Name}}] <span *ngIf="p.IsFromPool;">[{{'PoolProduct' | translate}}]</span></p>
                  </div>
                </div>

            </div>

            <div class="ReceptionProductsRow" style="height: 50px;border: none;">
                <div class="ReceptionProductsCol" style="width: 15%;margin-top: 5px;">
                    <mat-slide-toggle [(ngModel)]="NewProductPriceContainsVAT"(change)="priceContainsVATchanged($event);">{{ 'Receptions.Table.PriceContainsVAT' | translate }}</mat-slide-toggle>
                </div>
                <div class="ReceptionProductsCol" style="width: 15%;text-align: left;padding-left: 1%;">
                  <p class="NewTextBoxContainerTitle">{{ 'HOME.ProductType' | translate }}</p>
                  <div class="CustomDropdownContainer" *ngIf="NewProduct.ID == null;">
                    <div class="DropdownOverlayTransparent" *ngIf="showProductTypeDropdown" (click)="showProductTypeDropdown = false"></div>
                    <div class="CustomDropdownBar" [class.open]="showProductTypeDropdown" (click)="showProductTypeDropdown = !showProductTypeDropdown">
                      <span class="dropdown-label">{{ 'HOME.ProductType' | translate }}</span>
                      <i class="material-icons dropdown-icon-left">category</i>
                      <input type="text" class="CustomDropdownInput" [class.placeholder]="!NewProduct.GeneralType?.Name" [value]="NewProduct.GeneralType?.Name || ('HOME.ProductType' | translate)" readonly />
                      <i class="material-icons dropdown-icon">arrow_drop_down</i>
                    </div>
                    <div class="CustomDropdownResults" *ngIf="showProductTypeDropdown">
                      <div class="CustomDropdownResult" *ngFor="let t of this.ProductGeneralTypes" [class.selected]="compareFirst(NewProduct.GeneralType, t)" (click)="NewProduct.GeneralType = t; showProductTypeDropdown = false; chanveNewProductVALUE($event);">
                        <div class="CustomDropdownResultMain">
                          <span class="CustomDropdownResultText">{{t.Name}}</span>
                        </div>
                        <i class="material-icons CustomDropdownResultCheck" *ngIf="compareFirst(NewProduct.GeneralType, t)">check</i>
                      </div>
                    </div>
                  </div>

                  <div class="NewTextBoxContainer" style="width: 100%;" *ngIf="NewProduct.ID != null;">
                    <input type="text" class="NewTextBox" disabled="disabled" placeholder="{{ 'HOME.ProductType' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.GeneralType.Name">
                  </div>
                </div>
                <div class="ReceptionProductsCol" style="width: 20%;">
                  
                </div>
                <div class="ReceptionProductsCol" style="width: 5%;">
                   
                </div>
                <div class="ReceptionProductsCol">
                   
                </div>
                <div class="ReceptionProductsCol">
                   
                </div>
                <div class="ReceptionProductsCol" style="width: 5%;">
                  
                </div>
                <div class="ReceptionProductsCol" style="width: 5%;">
                   
                </div>
                <div class="ReceptionProductsCol" style="width: 5%;">
                   
                </div>
                <div class="ReceptionProductsCol" style="width: 5%;">
                  
                </div>
            </div>

            <div class="ReceptionProductsHeadder ReceptionProductsRow" style="border: none;">
                <div class="ReceptionProductsCol">
                    {{ 'Receptions.Table.Nr' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                    {{ 'Receptions.Administration' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 20%;text-align: left;padding-left: 1%;">
                    {{ 'Receptions.Table.Name' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    {{ 'Receptions.Table.Code' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    {{ 'Receptions.Table.MU' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    {{ 'Receptions.Table.Qty' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    {{ 'Receptions.Table.DocQty' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                    {{ 'Receptions.Table.Price' | translate }}  ({{currency.Name}})
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                    {{ 'Receptions.Table.Total' | translate }} ({{currency.Name}})
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    {{ 'Receptions.Table.VAT' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                  <i class="material-icons" style="cursor: pointer;font-size: 18px;" *ngIf="!loadingPOMatch && this.Products?.length > 0" (click)="LoadPOProductInfoBulk();" matTooltip="Match PO Prices" matTooltipClass='neutral-tool-tip'>sync</i>
                  <span style="color: #f60;font-size: 12px;font-weight: 500;" *ngIf="loadingPOMatch">{{loadingPOMatchIndex}}/{{loadingPOMatchTotal}}</span>
                </div>
            </div>

            <ng-container *ngFor="let p of this.Products; let i=index;">
              <div [ngClass]="{'NewProductAlertColor': p.ID == null || p.ID == 0, 'PoolProductAlert': p.IsFromPool}" class="ReceptionProductsRow ReceptionProductsRowHover" (dblclick)="OpenReceptionEditProduct(p.ProductReceptionInfo.UIID);CurrentIndexProduct = i;">
                <div class="ReceptionProductsCol">
                    {{i + 1}}
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                    <p>{{p.ProductReceptionInfo.Administration.Name}}</p>
                    <p class="NewProductAlert" *ngIf="p.ID == null || p.ID == 0;">[{{'NewProduct' | translate}}]</p>
                    <p class="PoolProductAlertRow" *ngIf="p.IsFromPool;">[{{'PoolProduct' | translate}}]</p>
                </div>
                <div class="ReceptionProductsCol" style="width: 20%;text-align: left;padding-left: 1%;">
                  <p>{{p.ProductReceptionInfo.Name}}</p>
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                  <p>{{p.ProductReceptionInfo.Code}}</p>
                  <p class="ReceptionProductsColDesc">{{p.ProductReceptionInfo.GeneralType.Name}}</p>
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                  {{p.ProductReceptionInfo.MeasuringUnit.Name}}
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                  {{p.ProductReceptionInfo.Quantity}}
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                  {{p.ProductReceptionInfo.DocQuantity}}
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                  <span *ngIf="p.ProductReceptionInfo.Price.Discount == null || p.ProductReceptionInfo.Price.Discount.Value == null">{{p.ProductReceptionInfo.Price.UIUnitPrice}}</span>
                  <span *ngIf="p.ProductReceptionInfo.Price.Discount != null && p.ProductReceptionInfo.Price.Discount.Value != null">{{p.ProductReceptionInfo.Price.UIUnitPriceDiscount}}</span>
                  <p matTooltip="{{p.ProductReceptionInfo.ExpectedPOProductInfo.Status.Description}}" matTooltipClass='neutral-tool-tip-management' class="ExpectedPOPrice" *ngIf="p.ProductReceptionInfo.ExpectedPOProductInfo?.Price > 0;"  [ngClass]="{'PriceDifference': p.ProductReceptionInfo.ExpectedPOProductInfo.Status.ID == -1, 'ExpectedPrice': p.ProductReceptionInfo.ExpectedPOProductInfo.Status.ID == 1, 'QuantityExceeded': p.ProductReceptionInfo.ExpectedPOProductInfo.Status.ID == -2}">
                    [{{p.ProductReceptionInfo.ExpectedPOProductInfo.Price}} {{p.ProductReceptionInfo.ExpectedPOProductInfo.CurrencyName}}]
                  </p>
                  <p matTooltip="{{p.ProductReceptionInfo.ExpectedPOProductInfo.Status.Description}}" matTooltipClass='neutral-tool-tip-management'  class="ExpectedPOPrice" *ngIf="p.ProductReceptionInfo.ExpectedPOProductInfo?.Price == 0;"  [ngClass]="{'PriceNotFound': p.ProductReceptionInfo.ExpectedPOProductInfo.Status.ID == 0}">
                    [{{p.ProductReceptionInfo.ExpectedPOProductInfo.Status.Name}}]
                  </p>
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                  <span *ngIf="p.ProductReceptionInfo.Price.Discount == null || p.ProductReceptionInfo.Price.Discount.Value == null">{{p.ProductReceptionInfo.Price.UIQtyPrice}}</span>
                  <span *ngIf="p.ProductReceptionInfo.Price.Discount != null && p.ProductReceptionInfo.Price.Discount.Value != null">{{p.ProductReceptionInfo.Price.UIQtyPriceDiscount}}</span>
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                  <span>{{p.ProductReceptionInfo.Price.TotalVATValue}}</span>
                </div>
                <div class="ReceptionProductsCol ReceptionProductActionsCol" style="width: 7.5%;">
                  <i class="material-icons ReceptionProductEdit" *ngIf="p.ProductReceptionInfo.GeneralType.ID != 1;" (click)="OpenProductTaxDivision(p.ProductReceptionInfo.UIID);">calculate</i>
                  <i class="material-icons ReceptionProductEdit" (click)="OpenReceptionEditProduct(p.ProductReceptionInfo.UIID);CurrentIndexProduct = i;">edit</i>
                  <div class="ReceptionProductEdit" (click)="OpenProductDiscountContainer(p);" *ngIf="CurrentReception.Total.Discount != undefined && CurrentReception.Total.Discount.Value == null;">%</div>
                  <i class="material-icons ReceptionProductEdit" style="color: red;" (click)="DeleteAuxProduct(p.ProductReceptionInfo.UIID);TestDocumentValidity();">close</i>
                </div>
              </div>

              <div class="ReceptionProductsRow ProductDiscountRow" style="background: #ddf4b9;cursor: pointer;min-height: 35px;" *ngIf="p.ProductReceptionInfo.GeneralType.ID != 1 && p.ProductReceptionInfo.GeneralType.IsTaxConsumed == true;" (click)="OpenProductTaxDivision(p.ProductReceptionInfo.UIID);">
                <div class="ReceptionProductsCol" style="width: 100%;text-align: left;padding-left: 1%;">
                  <span style="font-size: 11px;font-weight: 500;">{{ 'Receptions.Consumed' | translate }} ({{p.ProductReceptionInfo.GeneralType.TaxDivisionType.Name}})</span>
                </div>
              </div>

              <div class="ReceptionProductsRow ProductDiscountRow" style="background: #fff3cd;min-height: 35px;" *ngIf="p.ProductReceptionInfo.Price.Discount != null && p.ProductReceptionInfo.Price.Discount.Value != null">
                <div class="ReceptionProductsCol" style="width: 100%;text-align: left;padding-left: 1%;">
                  <span style="font-size: 11px;font-weight: 500;">
                    Discount - {{p.ProductReceptionInfo.Price.Discount.Value}}
                    <span *ngIf="p.ProductReceptionInfo.Price.Discount.Type.ID == 1;">%</span>
                    <span *ngIf="p.ProductReceptionInfo.Price.Discount.Type.ID == 2;">{{currency.Name}}</span>
                  </span>
                </div>
              </div>
            </ng-container>

          <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngIf="this.Products.length;">
            <div class="ReceptionProductsCol">
               
            </div>
            <div class="ReceptionProductsCol" style="width: 10%;">
                
            </div>
            <div class="ReceptionProductsCol" style="width: 20%;text-align: left;padding-left: 1%;">
              
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
              
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
             
            </div>
            <div class="ReceptionProductsCol" style="width: 15%;">
              <mat-form-field style="width: 100%;" appearance="outline">
                <mat-label>{{ 'Receptions.DecimalPercision' | translate }}</mat-label>
                <mat-select name="TotalRowDecimalPrecision" [compareWith]="compareFn" [(ngModel)]="TotalRowDecimalPrecision">
                  <mat-option *ngFor="let p of this.DecimalPrecisions" [value]="p" (onSelectionChange)="chanveNewProductVALUE($event);" (click)="GetReceptionTotalValues();">
                    {{p.Meaning}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="ReceptionProductsCol" style="width: 10%;">
              Total:
            </div>
            <div class="ReceptionProductsCol" style="width: 10%;">
              {{this.CurrentReception.Total.TotalQtyPriceNOVAT}}
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
              {{this.CurrentReception.Total.TotalVAT}}
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
              {{this.CurrentReception.Total.TotalQtyPriceVAT}}
            </div>
        </div>

        <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngIf="this.Products.length;">
          <div class="ReceptionProductsCol">
             
          </div>
          <div class="ReceptionProductsCol" style="width: 10%;">
            <button mat-button color="warn" (click)="EliminateDocumentDiscount();" *ngIf="CurrentReception.Total.Discount != null && CurrentReception.Total.Discount.Value != null">
              <i class="material-icons buttonIcon">close</i>
              {{ 'Receptions.EliminateDiscount' | translate }}
             </button>
          </div>
          <div class="ReceptionProductsCol" style="width: 20%;text-align: left;padding-left: 1%;">
            
          </div>
          <div class="ReceptionProductsCol" style="width: 7.5%;">
            
          </div>
          <div class="ReceptionProductsCol" style="width: 7.5%;">
           
          </div>
          <div class="ReceptionProductsCol" style="width: 15%;">
            
          </div>
          <div class="ReceptionProductsCol" style="width: 10%;">
            <div class="ProductGeneralDiscountRow" *ngIf="CurrentReception.Total.Discount != null && CurrentReception.Total.Discount.Value != null">
              <p style="padding-top: 0px;line-height: 35px;overflow: hidden;">
                Discount - {{CurrentReception.Total.Discount.Value}}
                <span *ngIf="CurrentReception.Total.Discount.Type.ID == 1;">%</span>
                <span *ngIf="CurrentReception.Total.Discount.Type.ID == 2;">{{currency.Name}}</span>
              </p>
          </div>
          </div>
          <div class="ReceptionProductsCol" style="width: 25%;text-align: right;padding-right: 10px;">
            <button mat-button color="primary" (click)="OpenDocumentDiscountContainer();">{{ 'Receptions.DocDiscount' | translate }} %</button>
          </div>
      </div>

        </div>

        <div class="ReceptionBottomCommands">
          <div class="BottomCommandsOverlay" *ngIf="!ValidDocument;"></div>

          <!-- Row 1: 3 Textboxes side by side -->
          <div class="BottomCommandsRow">
            <div class="BottomCommandsTextareaWrapper">
              <div class="NewTextBoxContainer">
                <input type="text" class="NewTextBox"
                       placeholder="{{ 'Receptions.Mentions' | translate }}"
                       [(ngModel)]="CurrentReception.Details.Observations" />
              </div>
            </div>

            <div class="BottomCommandsTextareaWrapper">
              <div class="NewTextBoxContainer">
                <input type="text" class="NewTextBox"
                       placeholder="{{ 'Receptions.ReceptionComittee' | translate }}"
                       [(ngModel)]="CurrentReception.Details.ReceptionCommittee" />
              </div>
            </div>

            <div class="BottomCommandsTextareaWrapper">
              <div class="NewTextBoxContainer">
                <input type="text" class="NewTextBox"
                       placeholder="{{ 'Receptions.Delegate' | translate }}"
                       [(ngModel)]="CurrentReception.Details.Delegate" />
              </div>
            </div>
          </div>

          <!-- Row 2: 2 Textboxes + empty space -->
          <div class="BottomCommandsRow">
            <div class="BottomCommandsTextareaWrapper">
              <div class="NewTextBoxContainer">
                <input type="text" class="NewTextBox"
                       placeholder="{{ 'Receptions.InternalCommentary' | translate }}"
                       [(ngModel)]="CurrentReception.Details.InternalCommentary" />
              </div>
            </div>

            <div class="BottomCommandsTextareaWrapper">
              <div class="NewTextBoxContainer">
                <input type="text" class="NewTextBox"
                       placeholder="{{ 'Receptions.Auto' | translate }}"
                       [(ngModel)]="CurrentReception.Details.Auto" />
              </div>
            </div>

            <div class="BottomCommandsTextareaWrapper">
              <!-- Empty space for alignment -->
            </div>
          </div>

          <!-- Row 3: Action Buttons in horizontal flow -->
          <div class="BottomCommandsButtonsRow">
            <button class="ModernButton ModernButtonPrimary" (click)="InitializeNewPayment();" *ngIf="this.CurrentReception.ID != null;">
              <i class="material-icons">payment</i>
              <span>{{'NewPayment' | translate}}</span>
            </button>
            <button class="ModernButton ModernButtonPrimary" (click)="InitializeNewPaymentOnNewReception();" *ngIf="this.CurrentReception.ID == null;">
              <i class="material-icons">payment</i>
              <span>{{'NewPayment' | translate}}</span>
            </button>

            <button type="button" class="ModernButton ModernButtonSecondary" (click)="GetShippingDetails(this.CurrentReception.Details?.ID, this.CurrentReception.Supplier?.ID);">
              <i class="material-icons">local_shipping</i>
              <span>{{'ShippingDetails' | translate}}</span>
            </button>

            <div class="BottomCommandsToggleInline">
              <mat-slide-toggle (change)="ChangeReceivedStatus();" [(ngModel)]="this.CurrentReception.Details.ReceivedStatus.Received" matTooltip="{{'PaymentApprovalStatusDesc' | translate}}" matTooltipClass='neutral-tool-tip'>{{this.CurrentReception.Details.ReceivedStatus?.Name}}</mat-slide-toggle>
            </div>

            <div class="BottomCommandsToggleInline">
              <mat-slide-toggle [(ngModel)]="this.CurrentReception.Details.ForceDocumentClosing" matTooltip="{{'ForceDocumentClosingDesc' | translate}}" matTooltipClass='neutral-tool-tip'>{{'ForceDocumentClosing' | translate}}</mat-slide-toggle>
            </div>
          </div>

          <!-- Row 4: Save Button - Centered -->
          <div class="BottomCommandsSaveRow">
            <button class="ModernButton ModernButtonPrimary ModernButtonLarge" (click)="AddReception();" *ngIf="CurrentReception.ID == null;">
              <i class="material-icons">save_alt</i>
              <span *ngIf="!IsStorno;">{{ 'Receptions.SaveReception' | translate }}</span>
              <span *ngIf="IsStorno;">{{ 'Receptions.StornoReception' | translate }}</span>
            </button>

            <button class="ModernButton ModernButtonPrimary ModernButtonLarge" (click)="UpdateReception();" *ngIf="CurrentReception.ID != null;">
              <i class="material-icons">save_alt</i>
              <span *ngIf="!IsStorno;">{{ 'Receptions.UpdateReception' | translate }}</span>
              <span *ngIf="IsStorno;">{{ 'Receptions.ModifyStorno' | translate }}</span>
            </button>
          </div>
        </div>
    </div>
</div>

<!-- Add New Partner Popup - Outside DocumentContainer for full viewport overlay -->
<div class="PopUpOverlay" *ngIf="showAddNewPartnerPopUp" (click)="showAddNewPartnerPopUp = false;"></div>

<div *ngIf="showAddNewPartnerPopUp" class="animated fadeInDown NewPartnerPopUp">
    <div class="PopUpCloseContainer" (click)="showAddNewPartnerPopUp = false;">
      <i class="material-icons">close</i>
    </div>
    <div class="PopUpTitleContainer">
     <p>{{ 'Partners.AddNewPartner' | translate }}</p>
    </div>

    <div class="PopUpBody">

      <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.General' | translate }}</p>

      <form [formGroup]="newPartner">
        <p class="NewTextBoxContainerTitle">{{ 'Partners.VAT' | translate }}</p>
        <div class="NewTextBoxContainer PopUpBodySemiTextBox">
          <input type="text" class="NewTextBox" placeholder="ex. RO1234567" value="" autocomplete="off" formControlName="VAT">
          <i class="material-icons CheckEUVATButton" (click)="GetPartnerEUData(this.newPartner, true);" *ngIf="this.newPartner.controls['VAT'].value != null && this.newPartner.controls['VAT'].value.length && this.newPartner.controls['Country'].value != null;">cloud_download</i>
        </div>

        <p class="NewTextBoxContainerTitle">{{ 'Partners.UPN' | translate }}</p>
        <div class="NewTextBoxContainer PopUpBodySemiTextBox">
          <input type="text" class="NewTextBox" placeholder="ex. CNP - RO" value="" autocomplete="off" formControlName="UPN">
        </div>

        <p class="NewTextBoxContainerTitle">{{ 'Partners.Name' | translate }}</p>
        <div class="NewTextBoxContainer PopUpBodySemiTextBox">
          <input type="text" class="NewTextBox" placeholder="" value="" autocomplete="off" formControlName="Name" required>
        </div>

        <p class="NewTextBoxContainerTitle">{{ 'Partners.PartnerWindow.COCRegNumber' | translate }}</p>
        <div class="NewTextBoxContainer PopUpBodySemiTextBox">
          <input type="text" class="NewTextBox" placeholder="" value="" autocomplete="off" formControlName="COCRegNumber">
        </div>

        <div class="PopUpBodySemiTextBox">
          <mat-slide-toggle formControlName="TaxPayer">{{ 'Partners.PartnerWindow.TaxPayer' | translate }}</mat-slide-toggle>
        </div>

        <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.Address' | translate }}</p>

        <p class="NewTextBoxContainerTitle">{{ 'Partners.PartnerWindow.ChooseCountry' | translate }}</p>
        <div class="CustomDropdownContainer">
          <div class="DropdownOverlayTransparent" *ngIf="showCountryDropdown" (click)="showCountryDropdown = false"></div>
          <div class="CustomDropdownBar" [class.open]="showCountryDropdown" (click)="showCountryDropdown = !showCountryDropdown">
            <span class="dropdown-label">{{ 'Partners.PartnerWindow.ChooseCountry' | translate }}</span>
            <i class="material-icons dropdown-icon-left">public</i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!newPartnerCountry?.Name" [value]="newPartnerCountry?.Name || ('Partners.PartnerWindow.ChooseCountry' | translate)" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showCountryDropdown">
            <div class="CustomDropdownResult" *ngFor="let c of parent.masterData.Countries" [class.selected]="compareFn(newPartnerCountry, c)" (click)="newPartnerCountry = c; newPartner.controls['Country'].setValue(c); showCountryDropdown = false;">
              <div class="CustomDropdownResultMain">
                <span class="CustomDropdownResultText">{{c.Name}}</span>
              </div>
              <i class="material-icons CustomDropdownResultCheck" *ngIf="compareFn(newPartnerCountry, c)">check</i>
            </div>
          </div>
        </div>

        <p class="NewTextBoxContainerTitle">{{ 'Partners.PartnerWindow.StateProvince' | translate }}</p>
        <div class="NewTextBoxContainer PopUpBodySemiTextBox">
          <input type="text" class="NewTextBox" placeholder="" value="" autocomplete="off" formControlName="StateProvince">
        </div>

        <p class="NewTextBoxContainerTitle">{{ 'Partners.PartnerWindow.City' | translate }}</p>
        <div class="NewTextBoxContainer PopUpBodySemiTextBox">
          <input type="text" class="NewTextBox" placeholder="" value="" autocomplete="off" formControlName="City">
        </div>

        <p class="NewTextBoxContainerTitle">{{ 'Partners.PartnerWindow.AddressLine' | translate }}</p>
        <div class="NewTextBoxContainer PopUpBodySemiTextBox">
          <input type="text" class="NewTextBox" placeholder="" value="" autocomplete="off" formControlName="AddressLine" required>
        </div>

        <p class="NewTextBoxContainerTitle">{{ 'ZipCode' | translate }}</p>
        <div class="NewTextBoxContainer PopUpBodySemiTextBox">
          <input type="text" class="NewTextBox" placeholder="" value="" autocomplete="off" formControlName="ZipCode">
        </div>

        <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.Bank' | translate }}:</p>

        <p class="NewTextBoxContainerTitle">{{ 'Partners.PartnerWindow.ChooseBank' | translate }}</p>
        <div class="CustomDropdownContainer">
          <div class="DropdownOverlayTransparent" *ngIf="showBankDropdown" (click)="showBankDropdown = false"></div>
          <div class="CustomDropdownBar" [class.open]="showBankDropdown" (click)="showBankDropdown = !showBankDropdown">
            <span class="dropdown-label">{{ 'Partners.PartnerWindow.ChooseBank' | translate }}</span>
            <i class="material-icons dropdown-icon-left">account_balance</i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!newPartnerBank?.Name" [value]="newPartnerBank?.Name || ('Partners.PartnerWindow.ChooseBank' | translate)" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showBankDropdown">
            <div class="CustomDropdownResult" *ngFor="let b of parent.masterData.Banks" [class.selected]="compareFn(newPartnerBank, b)" (click)="newPartnerBank = b; newPartner.controls['Bank'].setValue(b); showBankDropdown = false;">
              <div class="CustomDropdownResultMain">
                <span class="CustomDropdownResultText">{{b.Name}}</span>
              </div>
              <i class="material-icons CustomDropdownResultCheck" *ngIf="compareFn(newPartnerBank, b)">check</i>
            </div>
          </div>
        </div>

        <p class="NewTextBoxContainerTitle" *ngIf="newPartnerBank != null;">{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }}</p>
        <div class="NewTextBoxContainer PopUpBodySemiTextBox" *ngIf="newPartnerBank != null;">
          <input type="text" class="NewTextBox" placeholder="" value="" autocomplete="off" formControlName="BankAccount">
        </div>

        <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.ContactInfo' | translate }}</p>

        <p class="NewTextBoxContainerTitle">{{ 'Login.Email' | translate }}</p>
        <div class="NewTextBoxContainer PopUpBodySemiTextBox">
          <input type="text" class="NewTextBox" placeholder="" value="" autocomplete="off" formControlName="Email">
        </div>

        <p class="NewTextBoxContainerTitle">{{ 'Partners.PartnerWindow.Name' | translate }}</p>
        <div class="NewTextBoxContainer PopUpBodySemiTextBox">
          <input type="text" class="NewTextBox" placeholder="" value="" autocomplete="off" formControlName="ContactName">
        </div>

        <p class="NewTextBoxContainerTitle">{{ 'Login.Phone' | translate }}</p>
        <div class="NewTextBoxContainer PopUpBodySemiTextBox">
          <input type="text" class="NewTextBox" placeholder="" value="" autocomplete="off" formControlName="Phone">
        </div>
      </form>

    </div>

    <div class="PopUpCommands">
      <button [disabled]="parent.loading" class="ModernButton ModernButtonPrimary" matTooltip="Submit Partner" (click)="AddNewPartner();">
        <i class="material-icons">add</i>
        <span>{{'Partners.AddNewPartner' | translate}}</span>
      </button>
    </div>
  </div>

<!-- Edit Partner Popup - Outside DocumentContainer for full viewport overlay -->
<div class="PopUpOverlay" *ngIf="showEditPartnerPopUp" (click)="showEditPartnerPopUp = false;"></div>

<div *ngIf="showEditPartnerPopUp" class="animated fadeInDown NewPartnerPopUp">
    <div class="PopUpCloseContainer" (click)="showEditPartnerPopUp = false;">
      <i class="material-icons">close</i>
    </div>
    <div class="PopUpTitleContainer">
     <p>{{ 'Partners.EditPartner' | translate }}</p>
    </div>

    <div class="PopUpBody">

      <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.General' | translate }}</p>

      <form [formGroup]="currentPartner">
        <p class="NewTextBoxContainerTitle">{{ 'Partners.VAT' | translate }}</p>
        <div class="NewTextBoxContainer PopUpBodySemiTextBox">
          <input type="text" class="NewTextBox" placeholder="ex. RO1234567" value="" autocomplete="off" formControlName="VAT">
          <i class="material-icons CheckEUVATButton" (click)="GetPartnerEUData(this.currentPartner, false);" *ngIf="this.currentPartner.controls['VAT'].value != null && this.currentPartner.controls['VAT'].value.length;">cloud_download</i>
        </div>

        <p class="NewTextBoxContainerTitle">{{ 'Partners.UPN' | translate }}</p>
        <div class="NewTextBoxContainer PopUpBodySemiTextBox">
          <input type="text" class="NewTextBox" placeholder="ex. CNP - RO" value="" autocomplete="off" formControlName="UPN">
        </div>

        <p class="NewTextBoxContainerTitle">{{ 'Partners.PartnerWindow.Name' | translate }}</p>
        <div class="NewTextBoxContainer PopUpBodySemiTextBox">
          <input type="text" class="NewTextBox" placeholder="" value="" autocomplete="off" formControlName="Name" required>
        </div>

        <p class="NewTextBoxContainerTitle">{{ 'Partners.PartnerWindow.COCRegNumber' | translate }}</p>
        <div class="NewTextBoxContainer PopUpBodySemiTextBox">
          <input type="text" class="NewTextBox" placeholder="" value="" autocomplete="off" formControlName="COCRegNumber">
        </div>

        <div class="PopUpBodySemiTextBox">
          <mat-slide-toggle formControlName="TaxPayer">{{ 'Partners.PartnerWindow.TaxPayer' | translate }}</mat-slide-toggle>
        </div>

        <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.Address' | translate }}</p>

        <p class="NewTextBoxContainerTitle">{{ 'Partners.PartnerWindow.ChooseCountry' | translate }}</p>
        <div class="CustomDropdownContainer">
          <div class="DropdownOverlayTransparent" *ngIf="showEditCountryDropdown" (click)="showEditCountryDropdown = false"></div>
          <div class="CustomDropdownBar" [class.open]="showEditCountryDropdown" (click)="showEditCountryDropdown = !showEditCountryDropdown">
            <span class="dropdown-label">{{ 'Partners.PartnerWindow.ChooseCountry' | translate }}</span>
            <i class="material-icons dropdown-icon-left">public</i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!currentPartner.controls['Country'].value?.Name" [value]="currentPartner.controls['Country'].value?.Name || ('Partners.PartnerWindow.ChooseCountry' | translate)" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showEditCountryDropdown">
            <div class="CustomDropdownResult" *ngFor="let c of parent.masterData.Countries" [class.selected]="compareFn(currentPartner.controls['Country'].value, c)" (click)="currentPartner.controls['Country'].setValue(c); showEditCountryDropdown = false;">
              <div class="CustomDropdownResultMain">
                <span class="CustomDropdownResultText">{{c.Name}}</span>
              </div>
              <i class="material-icons CustomDropdownResultCheck" *ngIf="compareFn(currentPartner.controls['Country'].value, c)">check</i>
            </div>
          </div>
        </div>

        <p class="NewTextBoxContainerTitle">{{ 'Partners.PartnerWindow.StateProvince' | translate }}</p>
        <div class="NewTextBoxContainer PopUpBodySemiTextBox">
          <input type="text" class="NewTextBox" placeholder="" value="" autocomplete="off" formControlName="StateProvince" required>
        </div>

        <p class="NewTextBoxContainerTitle">{{ 'Partners.PartnerWindow.City' | translate }}</p>
        <div class="NewTextBoxContainer PopUpBodySemiTextBox">
          <input type="text" class="NewTextBox" placeholder="" value="" autocomplete="off" formControlName="City" required>
        </div>

        <p class="NewTextBoxContainerTitle">{{ 'Partners.PartnerWindow.AddressLine' | translate }}</p>
        <div class="NewTextBoxContainer PopUpBodySemiTextBox">
          <input type="text" class="NewTextBox" placeholder="" value="" autocomplete="off" formControlName="AddressLine" required>
        </div>

        <p class="NewTextBoxContainerTitle">{{ 'ZipCode' | translate }}</p>
        <div class="NewTextBoxContainer PopUpBodySemiTextBox">
          <input type="text" class="NewTextBox" placeholder="" value="" autocomplete="off" formControlName="ZipCode">
        </div>

        <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.Bank' | translate }}</p>

        <p class="NewTextBoxContainerTitle">{{ 'Partners.PartnerWindow.ChooseBank' | translate }}</p>
        <div class="CustomDropdownContainer">
          <div class="DropdownOverlayTransparent" *ngIf="showEditBankDropdown" (click)="showEditBankDropdown = false"></div>
          <div class="CustomDropdownBar" [class.open]="showEditBankDropdown" (click)="showEditBankDropdown = !showEditBankDropdown">
            <span class="dropdown-label">{{ 'Partners.PartnerWindow.ChooseBank' | translate }}</span>
            <i class="material-icons dropdown-icon-left">account_balance</i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!currentPartner.controls['Bank'].value?.Name" [value]="currentPartner.controls['Bank'].value?.Name || ('Partners.PartnerWindow.ChooseBank' | translate)" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showEditBankDropdown">
            <div class="CustomDropdownResult" *ngFor="let b of parent.masterData.Banks" [class.selected]="compareFn(currentPartner.controls['Bank'].value, b)" (click)="currentPartner.controls['Bank'].setValue(b); showEditBankDropdown = false;">
              <div class="CustomDropdownResultMain">
                <span class="CustomDropdownResultText">{{b.Name}}</span>
              </div>
              <i class="material-icons CustomDropdownResultCheck" *ngIf="compareFn(currentPartner.controls['Bank'].value, b)">check</i>
            </div>
          </div>
        </div>

        <p class="NewTextBoxContainerTitle">{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }}</p>
        <div class="NewTextBoxContainer PopUpBodySemiTextBox">
          <input type="text" class="NewTextBox" placeholder="" value="" autocomplete="off" formControlName="BankAccount">
        </div>

        <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.ContactInfo' | translate }}</p>

        <p class="NewTextBoxContainerTitle">{{ 'Login.Email' | translate }}</p>
        <div class="NewTextBoxContainer PopUpBodySemiTextBox">
          <input type="text" class="NewTextBox" placeholder="" value="" autocomplete="off" formControlName="Email">
        </div>

        <p class="NewTextBoxContainerTitle">{{ 'Partners.PartnerWindow.Name' | translate }}</p>
        <div class="NewTextBoxContainer PopUpBodySemiTextBox">
          <input type="text" class="NewTextBox" placeholder="" value="" autocomplete="off" formControlName="ContactName">
        </div>

        <p class="NewTextBoxContainerTitle">{{ 'Login.Phone' | translate }}</p>
        <div class="NewTextBoxContainer PopUpBodySemiTextBox">
          <input type="text" class="NewTextBox" placeholder="" value="" autocomplete="off" formControlName="Phone">
        </div>
      </form>

    </div>

    <div class="PopUpCommands">
      <button [disabled]="parent.loading" class="ModernButton ModernButtonPrimary" matTooltip="Submit Partner" (click)="UpdatePartner();">
        <i class="material-icons">save</i>
        <span>{{'UpdatePartner' | translate}}</span>
      </button>
    </div>
  </div>

<!-- Product Tax Division Popup - Outside DocumentContainer for full viewport overlay -->
<div class="PopUpOverlay" *ngIf="ShowProductTaxDivisionContainer" (click)="ShowProductTaxDivisionContainer = false;"></div>

<div class="animated fadeInDown ReceptionEditProductContainer" *ngIf="ShowProductTaxDivisionContainer">
  <div class="PopUpCloseContainer" (click)="ShowProductTaxDivisionContainer = false;">
    <i class="material-icons">close</i>
  </div>
  <div class="ReceptionEditProductTitleContainer">
   <p>{{ 'Receptions.ConsumeTax' | translate }} - {{this.CurrentProduct.ProductReceptionInfo.Name}}</p>
  </div>

  <div class="PopUpBody">
    <div class="PopUpBodyRow" style="min-height: 50px;padding-top: 10px;padding-left: 1%;">
      <mat-radio-group (change)="RadioChangeTaxDivisionType($event)" aria-labelledby="example-radio-group-label" class="example-radio-group">
        <mat-radio-button [checked]="type.ID === this.CurrentProduct.ProductReceptionInfo.GeneralType.TaxDivisionType.ID" [value]="type" class="LangRadio" *ngFor="let type of this.TaxDivisionTypes; index as i">{{type.Name}}</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="PopUpBodyRow" style="min-height: 50px;padding-top: 10px;padding-left: 1%;">
      {{this.CurrentProduct.ProductReceptionInfo.Name}} ({{this.CurrentProduct.ProductReceptionInfo.Code}})
    </div>

    <div class="PopUpBodyRow" *ngIf="IsLoadingTaxDivision">
      <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
    </div>

    <div *ngIf="!IsLoadingTaxDivision">
      <div class="ReceptionProductsHeadder ReceptionProductsRow" style="border: none;">
        <div class="ReceptionProductsCol">
            {{ 'Receptions.Table.Nr' | translate }}
        </div>
        <div class="ReceptionProductsCol" style="width: 10%;">
            {{ 'Receptions.Administration' | translate }}
        </div>
        <div class="ReceptionProductsCol" style="width: 20%;text-align: left;padding-left: 1%;">
            {{ 'Receptions.Table.Name' | translate }}
        </div>
        <div class="ReceptionProductsCol" style="width: 7.5%;">
            {{ 'Receptions.Table.Code' | translate }}
        </div>
        <div class="ReceptionProductsCol" style="width: 7.5%;">
            {{ 'Receptions.Table.MU' | translate }}
        </div>
        <div class="ReceptionProductsCol" style="width: 7.5%;">
            {{ 'Receptions.Table.Qty' | translate }}
        </div>
        <div class="ReceptionProductsCol" style="width: 7.5%;">
            {{ 'Receptions.Table.DocQty' | translate }}
        </div>
        <div class="ReceptionProductsCol" style="width: 20%;">
          Procent repartizare
        </div>
        <div class="ReceptionProductsCol" style="width: 15%;">
          Valoare repartizata
        </div>
    </div>

      <div class="ReceptionProductsRow ReceptionProductsRowHover" *ngFor="let p of this.Products; let i=index;">
      <div *ngIf="p.ProductReceptionInfo.GeneralType.ID == 1;">
        <div class="ReceptionProductsCol">
          {{i + 1}}
      </div>
      <div class="ReceptionProductsCol" style="width: 10%;">
          {{p.ProductReceptionInfo.Administration.Name}}
      </div>
      <div class="ReceptionProductsCol" style="width: 20%;text-align: left;padding-left: 1%;">
        <p>{{p.ProductReceptionInfo.Name}}</p>
      </div>
      <div class="ReceptionProductsCol" style="width: 7.5%;">
        {{p.ProductReceptionInfo.Code}}
        <p class="ReceptionProductsColDesc">{{p.ProductReceptionInfo.GeneralType.Name}}</p>
      </div>
      <div class="ReceptionProductsCol" style="width: 7.5%;">
        {{p.ProductReceptionInfo.MeasuringUnit.Name}}
      </div>
      <div class="ReceptionProductsCol" style="width: 7.5%;">
        {{p.ProductReceptionInfo.Quantity}}
      </div>
      <div class="ReceptionProductsCol" style="width: 7.5%;">
        {{p.ProductReceptionInfo.DocQuantity}}
      </div>
      <div class="ReceptionProductsCol" style="width: 20%;">
        {{p.ProductReceptionInfo.TaxDistribution.Percentage}}%
      </div>
        <div class="ReceptionProductsCol" style="width: 15%;">
          {{p.ProductReceptionInfo.TaxDistribution.QtyValue}}
        </div>
        </div>
      </div>
    </div>

  </div>

  <div class="PopUpCommands">
    <button class="ModernButton ModernButtonPrimary" (click)="SubmitTaxProductDistribution();">
      <i class="material-icons">read_more</i>
      <span>{{ 'Receptions.ConsumeTax' | translate }}</span>
    </button>
    <button class="ModernButton ModernButtonDanger" (click)="CancelTaxProductDistribution();" *ngIf="this.CurrentProduct.ProductReceptionInfo.GeneralType.IsTaxConsumed == true;">
      <i class="material-icons">close</i>
      <span>{{ 'Receptions.CancelTaxDistribution' | translate }}</span>
    </button>
  </div>

</div>

<!-- Edit Product Popup - Outside DocumentContainer for full viewport overlay -->
<div class="PopUpOverlay" *ngIf="ShowReceptionEditProductContainer" (click)="ShowReceptionEditProductContainer = false;RevertProduct();"></div>

<div class="animated fadeInDown ReceptionEditProductContainer" *ngIf="ShowReceptionEditProductContainer">
  <div class="PopUpCloseContainer" (click)="ShowReceptionEditProductContainer = false;RevertProduct();">
    <i class="material-icons">close</i>
  </div>
  <div class="ReceptionEditProductTitleContainer">
   <p>
    <i class="material-icons titleModificationIcon">build</i>
     {{CurrentProduct.ProductReceptionInfo.Name}}
    </p>
  </div>

  <div class="PopUpBody" *ngIf="!loadingEditProduct">
    <div class="PopUpBodyRowContainer" *ngIf="CurrentProduct.ID == null;">
      <div class="PopUpBodyTwoThirdsContainer">
        <p class="NewTextBoxContainerTitle">{{ 'Receptions.Administration' | translate }}</p>
        <div class="CustomDropdownContainer">
          <div class="DropdownOverlayTransparent" *ngIf="showEditProductAdministrationDropdown" (click)="showEditProductAdministrationDropdown = false"></div>
          <div class="CustomDropdownBar" [class.open]="showEditProductAdministrationDropdown" (click)="showEditProductAdministrationDropdown = !showEditProductAdministrationDropdown">
            <span class="dropdown-label">{{ 'Receptions.Administration' | translate }}</span>
            <i class="material-icons dropdown-icon-left">business</i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!CurrentProduct.ProductReceptionInfo.Administration?.Name" [value]="CurrentProduct.ProductReceptionInfo.Administration?.Name || ('Receptions.Administration' | translate)" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showEditProductAdministrationDropdown">
            <div class="CustomDropdownResult" *ngFor="let a of this.Administrations" [class.selected]="compareFirst(CurrentProduct.ProductReceptionInfo.Administration, a)" (click)="CurrentProduct.ProductReceptionInfo.Administration = a; showEditProductAdministrationDropdown = false;">
              <div class="CustomDropdownResultMain">
                <span class="CustomDropdownResultText">{{a.Name}}</span>
              </div>
              <i class="material-icons CustomDropdownResultCheck" *ngIf="compareFirst(CurrentProduct.ProductReceptionInfo.Administration, a)">check</i>
            </div>
          </div>
        </div>
      </div>

      <div class="PopUpBodyOneThirddContainer">
        <p class="NewTextBoxContainerTitle">{{ 'HOME.ProductType' | translate }}</p>
        <div class="CustomDropdownContainer">
          <div class="DropdownOverlayTransparent" *ngIf="showEditProductTypeDropdown" (click)="showEditProductTypeDropdown = false"></div>
          <div class="CustomDropdownBar" [class.open]="showEditProductTypeDropdown" (click)="showEditProductTypeDropdown = !showEditProductTypeDropdown">
            <span class="dropdown-label">{{ 'HOME.ProductType' | translate }}</span>
            <i class="material-icons dropdown-icon-left">category</i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!CurrentProduct.ProductReceptionInfo.GeneralType?.Name" [value]="CurrentProduct.ProductReceptionInfo.GeneralType?.Name || ('HOME.ProductType' | translate)" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showEditProductTypeDropdown">
            <div class="CustomDropdownResult" *ngFor="let t of this.ProductGeneralTypes" [class.selected]="compareFirst(CurrentProduct.ProductReceptionInfo.GeneralType, t)" (click)="CurrentProduct.ProductReceptionInfo.GeneralType = t; showEditProductTypeDropdown = false; chanveNewProductVALUE($event);">
              <div class="CustomDropdownResultMain">
                <span class="CustomDropdownResultText">{{t.Name}}</span>
              </div>
              <i class="material-icons CustomDropdownResultCheck" *ngIf="compareFirst(CurrentProduct.ProductReceptionInfo.GeneralType, t)">check</i>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="PopUpBodyRowContainer" *ngIf="CurrentProduct.ID != null;">
      <div class="PopUpBodyTwoThirdsContainer">
        <p class="NewTextBoxContainerTitle">{{ 'Receptions.Administration' | translate }}</p>
        <div class="NewTextBoxContainer">
          <input type="text" class="NewTextBox" disabled="disabled" placeholder="{{ 'Receptions.Administration' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductReceptionInfo.Administration.Name">
        </div>
      </div>

      <div class="PopUpBodyOneThirddContainer">
        <p class="NewTextBoxContainerTitle">{{ 'HOME.ProductType' | translate }}</p>
        <div class="NewTextBoxContainer">
          <input type="text" class="NewTextBox" disabled="disabled" placeholder="{{ 'HOME.ProductType' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductReceptionInfo.GeneralType.Name">
        </div>
      </div>

    </div>

    <div class="PopUpBodyRowContainer">
      <div class="PopUpBodyTwoThirdsContainer">
        <p class="NewTextBoxContainerTitle">{{ 'Receptions.Table.Name' | translate }}</p>
        <div class="NewTextBoxContainer">
          <input type="text" class="NewTextBox" placeholder="{{ 'Receptions.Table.Name' | translate }}" autocomplete="off" (click)="SearchProductsReceptionInformation(CurrentProduct.ProductReceptionInfo.Name, CurrentProduct.ProductReceptionInfo.Administration.ID, true); showhideSearches(true);" [(ngModel)]="CurrentProduct.ProductReceptionInfo.Name" (ngModelChange)="chanveNewProductVALUE($event); SearchProductsReceptionInformation(CurrentProduct.ProductReceptionInfo.Name, CurrentProduct.ProductReceptionInfo.Administration.ID, true);">
          <i class="material-icons" style="cursor: pointer;" *ngIf="ProductsSearchResultsCOUNTPop == 0 && !loadingSearchProducts && CurrentProduct.ProductReceptionInfo.Name.length == 0;">search</i>
          <i class="material-icons" style="cursor: pointer;" *ngIf="(ProductsSearchResultsCOUNTPop > 0 || CurrentProduct.ProductReceptionInfo.Name.length > 0) && !loadingSearchProducts;" (click)="DestroySearchedProducts();">close</i>
        </div>
        <div class="SpinnerIconContainer" *ngIf="loadingSearchProducts">
          <mat-spinner class="smallSpinner" [diameter]="25"></mat-spinner>
        </div>
      </div>
      <div class="PopUpBodyOneThirddContainer">
        <p class="NewTextBoxContainerTitle">{{ 'Receptions.Table.Code' | translate }}</p>
        <div class="NewTextBoxContainer">
          <input type="text" class="NewTextBox" [disabled]="CurrentProduct.ProductReceptionInfo.ProductID != null" placeholder="{{ 'Receptions.Table.Code' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductReceptionInfo.Code">
        </div>
      </div>
      <div class="ProductsSearchResultsContainer ProductsSearchResultsContainerPopException" *ngIf="ProductsSearchResultsCOUNTPop > 0 && this.showSearchCurrent == true;">
        <div class="ProductSearchResult" *ngFor="let p of ProductsSearchResultsPop" (click)="SelectReceptionProductFromSearchCurrent(p);">
            <p class="ProductSearchResultTitle">{{p.Name}}</p>
        </div>
      </div>
    </div>

    <div class="PopUpBodyRowContainer">
      <div class="PopUpBodyOneThirddContainer">
        <p class="NewTextBoxContainerTitle">{{ 'Receptions.Table.MU' | translate }}</p>
        <div class="CustomDropdownContainer">
          <div class="DropdownOverlayTransparent" *ngIf="showEditProductMUDropdown" (click)="showEditProductMUDropdown = false"></div>
          <div class="CustomDropdownBar" [class.open]="showEditProductMUDropdown" (click)="showEditProductMUDropdown = !showEditProductMUDropdown">
            <span class="dropdown-label">{{ 'Receptions.Table.MU' | translate }}</span>
            <i class="material-icons dropdown-icon-left">straighten</i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!CurrentProduct.ProductReceptionInfo.MeasuringUnit?.Name" [value]="CurrentProduct.ProductReceptionInfo.MeasuringUnit?.Name || ('Receptions.Table.MU' | translate)" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showEditProductMUDropdown">
            <div class="CustomDropdownResult" *ngFor="let u of this.MeasuringUnits" [class.selected]="compareFirst(CurrentProduct.ProductReceptionInfo.MeasuringUnit, u)" (click)="CurrentProduct.ProductReceptionInfo.MeasuringUnit = u; showEditProductMUDropdown = false;">
              <div class="CustomDropdownResultMain">
                <span class="CustomDropdownResultText">{{u.Name}}</span>
              </div>
              <i class="material-icons CustomDropdownResultCheck" *ngIf="compareFirst(CurrentProduct.ProductReceptionInfo.MeasuringUnit, u)">check</i>
            </div>
          </div>
        </div>
      </div>
      <div class="PopUpBodyOneThirddContainer">
        <p class="NewTextBoxContainerTitle">{{ 'Receptions.Table.Qty' | translate }}</p>
        <div class="NewTextBoxContainer">
          <input type="text" class="NewTextBox" placeholder="{{ 'Receptions.Table.Qty' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductReceptionInfo.Quantity">
        </div>
      </div>
      <div class="PopUpBodyOneThirddContainer">
        <p class="NewTextBoxContainerTitle">{{ 'Receptions.Table.DocQty' | translate }}</p>
        <div class="NewTextBoxContainer">
          <input type="text" class="NewTextBox" placeholder="{{ 'Receptions.Table.DocQty' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductReceptionInfo.DocQuantity">
        </div>
      </div>
    </div>

    <div class="PopUpBodyRowContainer">
      <div class="PopUpBodyOneThirddContainer">
        <p class="NewTextBoxContainerTitle">{{ 'Receptions.Table.PriceNOVAT' | translate }}</p>
        <div class="NewTextBoxContainer">
          <input type="text" class="NewTextBox" [disabled]="CurrentProduct.ProductReceptionInfo.PriceContainsVAT" placeholder="{{ 'Receptions.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductReceptionInfo.Price.UIUnitPrice" (change)="VerifyPriceModel(CurrentProduct.ProductReceptionInfo.Price.UIUnitPrice);">
        </div>
      </div>

       <div class="PopUpBodyOneThirddContainer">
        <p class="NewTextBoxContainerTitle">{{ 'Receptions.Table.PriceVAT' | translate }}</p>
        <div class="NewTextBoxContainer">
          <input type="text" class="NewTextBox" [disabled]="!CurrentProduct.ProductReceptionInfo.PriceContainsVAT" placeholder="{{ 'Receptions.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductReceptionInfo.Price.UIVATUnitPrice" (change)="VerifyPriceModel(CurrentProduct.ProductReceptionInfo.Price.UIVATUnitPrice);">
        </div>
      </div>

      <div class="PopUpBodyOneThirddContainer">
        <p class="NewTextBoxContainerTitle">{{ 'Receptions.Table.VAT' | translate }}</p>
        <div class="CustomDropdownContainer">
          <div class="DropdownOverlayTransparent" *ngIf="showEditProductVATDropdown" (click)="showEditProductVATDropdown = false"></div>
          <div class="CustomDropdownBar" [class.open]="showEditProductVATDropdown" (click)="showEditProductVATDropdown = !showEditProductVATDropdown">
            <span class="dropdown-label">{{ 'Receptions.Table.VAT' | translate }}</span>
            <i class="material-icons dropdown-icon-left">percent</i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!CurrentProduct.ProductReceptionInfo.Price.VAT?.Name" [value]="CurrentProduct.ProductReceptionInfo.Price.VAT?.Name || ('Receptions.Table.VAT' | translate)" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showEditProductVATDropdown">
            <div class="CustomDropdownResult" *ngFor="let v of this.VATRates" [class.selected]="compareFirst(CurrentProduct.ProductReceptionInfo.Price.VAT, v)" (click)="CurrentProduct.ProductReceptionInfo.Price.VAT = v; showEditProductVATDropdown = false; ModifyReceptionProduct(true);">
              <div class="CustomDropdownResultMain">
                <span class="CustomDropdownResultText">{{v.Name}}</span>
              </div>
              <i class="material-icons CustomDropdownResultCheck" *ngIf="compareFirst(CurrentProduct.ProductReceptionInfo.Price.VAT, v)">check</i>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="PopUpBodyRowContainer">
      <div class="PopUpBodyOneThirddContainer">
        <mat-slide-toggle (change)="priceContainsVATchanged($event)" [(ngModel)]="CurrentProduct.ProductReceptionInfo.PriceContainsVAT">{{ 'Receptions.Table.PriceContainsVAT' | translate }}</mat-slide-toggle>
      </div>
    </div>

    <div class="DiscountRow" *ngIf="CurrentProduct.ProductReceptionInfo.Price.Discount != null && CurrentProduct.ProductReceptionInfo.Price.Discount.Value != null && CurrentReception.Total.Discount.Value == null;">

      <p class="DiscountRowTitle">
        {{CurrentProduct.ProductReceptionInfo.Price.Discount.Type.Name}} Discount - {{CurrentProduct.ProductReceptionInfo.Price.Discount.Value}}
        <span *ngIf="CurrentProduct.ProductReceptionInfo.Price.Discount.Type.ID == 1;">%</span>
        <span> ({{currency.Name}})</span>
      </p>

      <div class="PopUpBodyOneThirddContainer">
        <p class="NewTextBoxContainerTitle">{{ 'Receptions.Table.PriceNOVAT' | translate }}</p>
        <div class="NewTextBoxContainer">
          <input type="text" class="NewTextBox" [disabled]="true" placeholder="{{ 'Receptions.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductReceptionInfo.Price.UIUnitPriceDiscount">
        </div>
      </div>

       <div class="PopUpBodyOneThirddContainer">
        <p class="NewTextBoxContainerTitle">{{ 'Receptions.Table.PriceVAT' | translate }}</p>
        <div class="NewTextBoxContainer">
          <input type="text" class="NewTextBox" [disabled]="true" placeholder="{{ 'Receptions.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductReceptionInfo.Price.UIVATUnitPriceDiscount">
        </div>
      </div>

        <div class="PopUpBodyRowContainer">
         <button mat-button color="warn" (click)="EliminateProductDiscount();">
          <i class="material-icons buttonIcon">close</i>
          {{ 'Receptions.EliminateDiscount' | translate }}
         </button>
        </div>
    </div>

  </div>

  <div class="PopUpBody" *ngIf="loadingEditProduct">
    <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
  </div>

  <div class="PopUpCommands">
    <button class="ModernButton ModernButtonPrimary" (click)="ModifyReceptionProduct();">
      <i class="material-icons">check</i>
      <span>{{'ModifyProduct' | translate}}</span>
    </button>
  </div>
</div>

<!-- Product Discount Popup - Outside DocumentContainer for full viewport overlay -->
<div class="PopUpOverlay" *ngIf="showProductDiscountContainer" (click)="showProductDiscountContainer = false;"></div>

<div class="animated fadeInDown DiscountContainer" *ngIf="showProductDiscountContainer">
  <div class="PopUpCloseContainer" (click)="showProductDiscountContainer = false;">
    <i class="material-icons">close</i>
  </div>

  <div class="PopUpTitleContainer">
    <p>{{ 'Receptions.MenuDiscount' | translate }}</p>
   </div>

   <div class="PopUpBody" style="margin-bottom: 0px;padding-top: 10px;">

    <p class="NewTextBoxContainerTitle">{{ 'Receptions.DiscountType' | translate }}</p>
    <div class="CustomDropdownContainer">
      <div class="DropdownOverlayTransparent" *ngIf="showProductDiscountTypeDropdown" (click)="showProductDiscountTypeDropdown = false"></div>
      <div class="CustomDropdownBar" [class.open]="showProductDiscountTypeDropdown" (click)="showProductDiscountTypeDropdown = !showProductDiscountTypeDropdown">
        <span class="dropdown-label">{{ 'Receptions.DiscountType' | translate }}</span>
        <i class="material-icons dropdown-icon-left">local_offer</i>
        <input type="text" class="CustomDropdownInput" [class.placeholder]="!CurrentProduct.ProductReceptionInfo.Price.Discount.Type?.Name" [value]="CurrentProduct.ProductReceptionInfo.Price.Discount.Type?.Name || ('Receptions.DiscountType' | translate)" readonly />
        <i class="material-icons dropdown-icon">arrow_drop_down</i>
      </div>
      <div class="CustomDropdownResults" *ngIf="showProductDiscountTypeDropdown">
        <div class="CustomDropdownResult" *ngFor="let d of this.DiscountTypes" [class.selected]="compareFn(CurrentProduct.ProductReceptionInfo.Price.Discount.Type, d)" (click)="CurrentProduct.ProductReceptionInfo.Price.Discount.Type = d; showProductDiscountTypeDropdown = false; chanveNewProductVALUE($event);">
          <div class="CustomDropdownResultMain">
            <span class="CustomDropdownResultText">{{d.Name}}</span>
          </div>
          <i class="material-icons CustomDropdownResultCheck" *ngIf="compareFn(CurrentProduct.ProductReceptionInfo.Price.Discount.Type, d)">check</i>
        </div>
      </div>
    </div>

    <p class="NewTextBoxContainerTitle">{{ 'Receptions.DiscountValue' | translate }}</p>
    <div class="NewTextBoxContainer">
      <i class="material-icons" style="color: #4a7bb8;">edit</i>
      <input type="text" class="NewTextBox" autocomplete="off" [(ngModel)]="CurrentProduct.ProductReceptionInfo.Price.Discount.Value" placeholder="{{ 'Receptions.DiscountValue' | translate }}">
    </div>

  </div>

   <div class="PopUpCommands">
    <button [disabled]="parent.loading" class="ModernButton ModernButtonPrimary" matTooltip="{{ 'Receptions.ApplyDiscount' | translate }}" (click)="ApplyDiscount();">
      <i class="material-icons">check</i>
      <span>{{ 'Receptions.ApplyDiscount' | translate }}</span>
    </button>
  </div>
</div>

<!-- Document Discount Popup - Outside DocumentContainer for full viewport overlay -->
<div class="PopUpOverlay" *ngIf="showDocumentDiscountContainer" (click)="showDocumentDiscountContainer = false;"></div>

<div class="animated fadeInDown DiscountContainer" *ngIf="showDocumentDiscountContainer">
  <div class="PopUpCloseContainer" (click)="showDocumentDiscountContainer = false;">
    <i class="material-icons">close</i>
  </div>

  <div class="PopUpTitleContainer">
    <p>{{ 'Receptions.DocDiscount' | translate }}</p>
   </div>

   <div class="PopUpBody" style="margin-bottom: 0px;padding-top: 10px;">

    <p class="NewTextBoxContainerTitle">{{ 'Receptions.DiscountType' | translate }}</p>
    <div class="CustomDropdownContainer">
      <div class="DropdownOverlayTransparent" *ngIf="showDocumentDiscountTypeDropdown" (click)="showDocumentDiscountTypeDropdown = false"></div>
      <div class="CustomDropdownBar" [class.open]="showDocumentDiscountTypeDropdown" (click)="showDocumentDiscountTypeDropdown = !showDocumentDiscountTypeDropdown">
        <span class="dropdown-label">{{ 'Receptions.DiscountType' | translate }}</span>
        <i class="material-icons dropdown-icon-left">local_offer</i>
        <input type="text" class="CustomDropdownInput" [class.placeholder]="!CurrentReception.Total.Discount.Type?.Name" [value]="CurrentReception.Total.Discount.Type?.Name || ('Receptions.DiscountType' | translate)" readonly />
        <i class="material-icons dropdown-icon">arrow_drop_down</i>
      </div>
      <div class="CustomDropdownResults" *ngIf="showDocumentDiscountTypeDropdown">
        <div class="CustomDropdownResult" *ngFor="let d of this.DiscountTypes" [class.selected]="compareFn(CurrentReception.Total.Discount.Type, d)" (click)="CurrentReception.Total.Discount.Type = d; showDocumentDiscountTypeDropdown = false;">
          <div class="CustomDropdownResultMain">
            <span class="CustomDropdownResultText">{{d.Name}}</span>
          </div>
          <i class="material-icons CustomDropdownResultCheck" *ngIf="compareFn(CurrentReception.Total.Discount.Type, d)">check</i>
        </div>
      </div>
    </div>

    <p class="NewTextBoxContainerTitle">{{ 'Receptions.DiscountValue' | translate }}</p>
    <div class="NewTextBoxContainer">
      <i class="material-icons" style="color: #4a7bb8;">edit</i>
      <input type="text" class="NewTextBox" autocomplete="off" [(ngModel)]="CurrentReception.Total.Discount.Value" placeholder="{{ 'Receptions.DiscountValue' | translate }}">
    </div>

  </div>

   <div class="PopUpCommands">
    <button [disabled]="parent.loading" class="ModernButton ModernButtonPrimary" matTooltip="{{ 'Receptions.ApplyDiscount' | translate }}" (click)="ApplyReceptionDiscount();">
      <i class="material-icons">check</i>
      <span>{{ 'Receptions.ApplyDiscount' | translate }}</span>
    </button>
  </div>
</div>

<!-- Shipping Details Popup - Outside DocumentContainer for full viewport overlay -->
<div class="PopUpOverlay" *ngIf="ShowShippingDetailsContainer" (click)="ShowShippingDetailsContainer = false;"></div>

<div *ngIf="ShowShippingDetailsContainer" class="ShippingDetailsPopUp animated fadeInDown">
  <div class="PopUpCloseContainer" (click)="ShowShippingDetailsContainer = false;">
    <i class="material-icons">close</i>
  </div>

  <div class="PopUpTitleContainer">
    <p>{{'ShippingDetails' | translate}}</p>
  </div>

  <div class="PopUpBody">
    <!-- General Shipping Information Section -->
    <p class="PopUpBodySubTitle">
      {{'GeneralShippingInformation' | translate}}
      <img *ngIf="this.CurrentReception.Details.ShippingDetails?.ShippingCompany?.ImagePath?.length > 0;"
           [src]="this.parent.BackendServiceUrl + this.CurrentReception.Details.ShippingDetails.ShippingCompany.ImagePath"
           class="ShippingCompanyLogo" />
    </p>

    <!-- Shipping Dropdowns - 2 columns -->
    <div class="ShippingDetailsGrid">
      <div class="ShippingDetailsColumn">
        <p class="NewTextBoxContainerTitle">{{ 'ShippingServiceType' | translate }}</p>
        <div class="CustomDropdownContainer">
          <div class="DropdownOverlayTransparent" *ngIf="showShippingServiceTypeDropdown" (click)="showShippingServiceTypeDropdown = false"></div>
          <div class="CustomDropdownBar" [class.open]="showShippingServiceTypeDropdown" (click)="showShippingServiceTypeDropdown = !showShippingServiceTypeDropdown">
            <span class="dropdown-label">{{ 'ShippingServiceType' | translate }}</span>
            <i class="material-icons dropdown-icon-left">local_shipping</i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!this.CurrentReception.Details.ShippingDetails.ShippingServiceType?.Name"
                   [value]="this.CurrentReception.Details.ShippingDetails.ShippingServiceType?.Name || ('ShippingServiceType' | translate)" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showShippingServiceTypeDropdown">
            <div class="CustomDropdownResult" *ngFor="let s of this.ShippingServiceTypes"
                 [class.selected]="compareFn(this.CurrentReception.Details.ShippingDetails.ShippingServiceType, s)"
                 (click)="this.CurrentReception.Details.ShippingDetails.ShippingServiceType = s; showShippingServiceTypeDropdown = false;">
              <div class="CustomDropdownResultMain">
                <span class="CustomDropdownResultText">{{s.Name}}</span>
              </div>
              <i class="material-icons CustomDropdownResultCheck" *ngIf="compareFn(this.CurrentReception.Details.ShippingDetails.ShippingServiceType, s)">check</i>
            </div>
          </div>
        </div>

        <p class="NewTextBoxContainerTitle">{{ 'ShippingResponsability' | translate }}</p>
        <div class="CustomDropdownContainer">
          <div class="DropdownOverlayTransparent" *ngIf="showShippingResponsabilityDropdown" (click)="showShippingResponsabilityDropdown = false"></div>
          <div class="CustomDropdownBar" [class.open]="showShippingResponsabilityDropdown" (click)="showShippingResponsabilityDropdown = !showShippingResponsabilityDropdown">
            <span class="dropdown-label">{{ 'ShippingResponsability' | translate }}</span>
            <i class="material-icons dropdown-icon-left">assignment_ind</i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!this.CurrentReception.Details.ShippingDetails.ShippingResponsability?.Name"
                   [value]="this.CurrentReception.Details.ShippingDetails.ShippingResponsability?.Name || ('ShippingResponsability' | translate)" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showShippingResponsabilityDropdown">
            <div class="CustomDropdownResult" *ngFor="let s of this.ShippingResponsabilities"
                 [class.selected]="compareFn(this.CurrentReception.Details.ShippingDetails.ShippingResponsability, s)"
                 (click)="this.CurrentReception.Details.ShippingDetails.ShippingResponsability = s; showShippingResponsabilityDropdown = false;">
              <div class="CustomDropdownResultMain">
                <span class="CustomDropdownResultText">{{s.Name}}</span>
              </div>
              <i class="material-icons CustomDropdownResultCheck" *ngIf="compareFn(this.CurrentReception.Details.ShippingDetails.ShippingResponsability, s)">check</i>
            </div>
          </div>
        </div>

        <p class="NewTextBoxContainerTitle">{{ 'WeightType' | translate }}</p>
        <div class="CustomDropdownContainer">
          <div class="DropdownOverlayTransparent" *ngIf="showWeightTypeDropdown" (click)="showWeightTypeDropdown = false"></div>
          <div class="CustomDropdownBar" [class.open]="showWeightTypeDropdown" (click)="showWeightTypeDropdown = !showWeightTypeDropdown">
            <span class="dropdown-label">{{ 'WeightType' | translate }}</span>
            <i class="material-icons dropdown-icon-left">scale</i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!this.CurrentReception.Details.ShippingDetails.WeightType?.Name"
                   [value]="this.CurrentReception.Details.ShippingDetails.WeightType?.Name || ('WeightType' | translate)" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showWeightTypeDropdown">
            <div class="CustomDropdownResult" *ngFor="let t of this.WeightTypes"
                 [class.selected]="compareFn(this.CurrentReception.Details.ShippingDetails.WeightType, t)"
                 (click)="this.CurrentReception.Details.ShippingDetails.WeightType = t; showWeightTypeDropdown = false;">
              <div class="CustomDropdownResultMain">
                <span class="CustomDropdownResultText">{{t.Name}}</span>
              </div>
              <i class="material-icons CustomDropdownResultCheck" *ngIf="compareFn(this.CurrentReception.Details.ShippingDetails.WeightType, t)">check</i>
            </div>
          </div>
        </div>
      </div>

      <div class="ShippingDetailsColumn">
        <p class="NewTextBoxContainerTitle">{{ 'ShippingWay' | translate }}</p>
        <div class="CustomDropdownContainer">
          <div class="DropdownOverlayTransparent" *ngIf="showShippingWayDropdown" (click)="showShippingWayDropdown = false"></div>
          <div class="CustomDropdownBar" [class.open]="showShippingWayDropdown" (click)="showShippingWayDropdown = !showShippingWayDropdown">
            <span class="dropdown-label">{{ 'ShippingWay' | translate }}</span>
            <i class="material-icons dropdown-icon-left">route</i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!this.CurrentReception.Details.ShippingDetails.ShippingWay?.Name"
                   [value]="this.CurrentReception.Details.ShippingDetails.ShippingWay?.Name || ('ShippingWay' | translate)" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showShippingWayDropdown">
            <div class="CustomDropdownResult" *ngFor="let s of this.ShippingWays"
                 [class.selected]="compareFn(this.CurrentReception.Details.ShippingDetails.ShippingWay, s)"
                 (click)="this.CurrentReception.Details.ShippingDetails.ShippingWay = s; showShippingWayDropdown = false;">
              <div class="CustomDropdownResultMain">
                <span class="CustomDropdownResultText">{{s.Name}}</span>
              </div>
              <i class="material-icons CustomDropdownResultCheck" *ngIf="compareFn(this.CurrentReception.Details.ShippingDetails.ShippingWay, s)">check</i>
            </div>
          </div>
        </div>

        <p class="NewTextBoxContainerTitle">{{ 'ShippingCompany' | translate }}</p>
        <div class="CustomDropdownContainer">
          <div class="DropdownOverlayTransparent" *ngIf="showShippingCompanyDropdown" (click)="showShippingCompanyDropdown = false"></div>
          <div class="CustomDropdownBar" [class.open]="showShippingCompanyDropdown" (click)="showShippingCompanyDropdown = !showShippingCompanyDropdown">
            <span class="dropdown-label">{{ 'ShippingCompany' | translate }}</span>
            <i class="material-icons dropdown-icon-left">business</i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!this.CurrentReception.Details.ShippingDetails.ShippingCompany?.Name"
                   [value]="this.CurrentReception.Details.ShippingDetails.ShippingCompany?.Name || ('ShippingCompany' | translate)" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showShippingCompanyDropdown">
            <div class="CustomDropdownResult" *ngFor="let s of this.ShippingCompanies"
                 [class.selected]="compareFn(this.CurrentReception.Details.ShippingDetails.ShippingCompany, s)"
                 (click)="this.CurrentReception.Details.ShippingDetails.ShippingCompany = s; showShippingCompanyDropdown = false;">
              <div class="CustomDropdownResultMain">
                <span class="CustomDropdownResultText">{{s.Name}}</span>
                <img *ngIf="s.ImagePath?.length > 0;" [src]="this.parent.BackendServiceUrl + s.ImagePath" class="ShippingCompanyLogoSmall" />
              </div>
              <i class="material-icons CustomDropdownResultCheck" *ngIf="compareFn(this.CurrentReception.Details.ShippingDetails.ShippingCompany, s)">check</i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Transported Boxes Section -->
    <p class="PopUpBodySubTitle">{{'TransportedBoxesInformation' | translate}}</p>

    <button class="ModernButton ModernButtonPrimary" (click)="AddNewBox();" style="margin-bottom: 15px;">
      <i class="material-icons">add_box</i>
      <span>{{'AddNewParcel' | translate}}</span>
    </button>

    <!-- Boxes List -->
    <div class="ShippingBoxesList" *ngIf="this.CurrentReception?.Details?.ShippingDetails?.Boxes?.length > 0;">
      <div class="ShippingBoxItem" *ngFor="let box of this.CurrentReception.Details.ShippingDetails.Boxes; let j=index;">
        <div class="ShippingBoxHeader">
          <span class="ShippingBoxTitle">
            <span *ngIf="box.IsPallet != true;">{{'Parcel' | translate}}</span>
            <span *ngIf="box.IsPallet == true;">{{'Pallet' | translate}}</span>
            <span> #{{j + 1}}</span>
          </span>
          <div class="ShippingBoxActions">
            <i class="material-icons ShippingBoxCheck" *ngIf="box.ID > 0;">check_circle</i>
            <i class="material-icons ShippingBoxDelete" (click)="CurrentBox = box; ShowDeleteBoxQuestion = true;">delete</i>
          </div>
        </div>

        <div class="ShippingBoxDimensions">
          <div class="ShippingBoxDimensionGroup">
            <p class="NewTextBoxContainerTitle">{{ 'Length' | translate }} × {{ 'Width' | translate }} × {{ 'Height' | translate }}</p>
            <div class="ShippingBoxDimensionInputs">
              <div class="NewTextBoxContainer" style="flex: 1;">
                <input type="text" class="NewTextBox" placeholder="{{ 'Length' | translate }}" autocomplete="off" [(ngModel)]="box.Length" (click)="$event.target.select()">
              </div>
              <span class="ShippingBoxDimensionSeparator">×</span>
              <div class="NewTextBoxContainer" style="flex: 1;">
                <input type="text" class="NewTextBox" placeholder="{{ 'Width' | translate }}" autocomplete="off" [(ngModel)]="box.Width" (click)="$event.target.select()">
              </div>
              <span class="ShippingBoxDimensionSeparator">×</span>
              <div class="NewTextBoxContainer" style="flex: 1;">
                <input type="text" class="NewTextBox" placeholder="{{ 'Height' | translate }}" autocomplete="off" [(ngModel)]="box.Height" (click)="$event.target.select()">
              </div>
            </div>
          </div>

          <div class="ShippingBoxWeightGroup">
            <p class="NewTextBoxContainerTitle">{{ 'Weight' | translate }}</p>
            <div class="NewTextBoxContainer">
              <i class="material-icons" style="color: #4a7bb8;">scale</i>
              <input type="text" class="NewTextBox" placeholder="{{ 'Weight' | translate }}" autocomplete="off" [(ngModel)]="box.Weight" (click)="$event.target.select()">
            </div>
          </div>
        </div>

        <div class="ShippingBoxTrackingRow">
          <div class="ShippingBoxTrackingInput">
            <p class="NewTextBoxContainerTitle">{{ 'TrackingLabel' | translate }}</p>
            <div class="NewTextBoxContainer">
              <i class="material-icons" style="color: #4a7bb8;">qr_code_2</i>
              <input type="text" class="NewTextBox" placeholder="{{ 'TrackingLabel' | translate }}" autocomplete="off" [(ngModel)]="box.TrackingLabel">
            </div>
          </div>

          <div class="ShippingBoxPalletCheckbox">
            <mat-checkbox [(ngModel)]="box.IsPallet">{{'Pallet' | translate}}?</mat-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="PopUpCommands">
    <button class="ModernButton ModernButtonDanger" *ngIf="this.CurrentReception.Details.ShippingDetails?.ID > 0;" (click)="ShowDeleteShippingDetailsContainer = true;">
      <i class="material-icons">delete_forever</i>
      <span>Delete</span>
    </button>
    <button class="ModernButton ModernButtonPrimary" (click)="ProofShippingDetails(this.CurrentReception.Details.ShippingDetails, true);">
      <i class="material-icons">save</i>
      <span>{{'SaveToDB' | translate}}</span>
    </button>
    <button class="ModernButton ModernButtonSecondary" (click)="ShowShippingDetailsContainer = false;">
      <i class="material-icons">check</i>
      <span>OK</span>
    </button>
  </div>
</div>

<!-- Cash Collection Popups - Outside DocumentContainer for full viewport overlay -->

<!-- ShowSuggestionPaymentsContainer - Detected Payments List -->
<div class="PopUpOverlay" *ngIf="ShowSuggestionPaymentsContainer" (click)="ShowSuggestionPaymentsContainer = false;"></div>

<div *ngIf="ShowSuggestionPaymentsContainer" class="CashCollectionContainer animated fadeInDown">
  <div class="PopUpCloseContainer" (click)="ShowSuggestionPaymentsContainer = false;">
    <i class="material-icons">close</i>
  </div>

  <div class="PopUpTitleContainer" style="height: auto;padding-left: 0;padding-right: 0;">
    <p>{{ 'DetectedPayments' | translate }}</p>

    <div class="ReceptionProductsHeadder ReceptionProductsRow" style="border: none;width: 95%;margin-left: 2.5%;margin-top: 15px;">
      <div class="ReceptionProductsCol" style="width: 5%;">
        {{ 'Document' | translate }}
      </div>
      <div class="ReceptionProductsCol" style="width: 15%;">
        {{ 'Supplier' | translate }}
      </div>
      <div class="ReceptionProductsCol" style="width: 10%;">
        {{ 'PaymentDate' | translate }}
      </div>
      <div class="ReceptionProductsCol" style="width: 10%;">
        {{ 'Value' | translate }}
      </div>
      <div class="ReceptionProductsCol" style="width: 10%;">
        {{ 'PaymentType' | translate }}
      </div>
      <div class="ReceptionProductsCol" style="width: 5%;">
          {{ 'Currency' | translate }}
      </div>
      <div class="ReceptionProductsCol" style="width: 5%;">
          {{ 'Receptions.ExchangeRate' | translate }}
        </div>
      <div class="ReceptionProductsCol" style="width: 10%;">
        {{ 'Receptions.DecimalPercision' | translate }}
      </div>
      <div class="ReceptionProductsCol" style="width: 20%;">
          {{ 'CollectionExternalID' | translate }}
      </div>
      <div class="ReceptionProductsCol" style="width: 10%;">
          {{ 'Actions' | translate }}
      </div>
    </div>
   </div>

   <div class="PopUpBody" style="margin-top: 5px;">

  <div class="ReceptionProductsContainer  top-box">

      <div class="ReceptionProductsRow TotalRow" *ngIf="loading">
          <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
      </div>

      <div *ngIf="!loading">
          <div class="ReceptionProductsRow" *ngFor="let c of this.CurrentReception.Details?.Payments; let i=index;" [ngClass]="{'UnAssociatedPayment': c.Status.ID == -1, 'AssociatedPayment': c.Status.ID == 1, 'DupplicateCC': c.IsDuplicate == true }">
              <div class="ReceptionProductsCol" style="width: 5%;">
               <span *ngIf="c.Status.ID == 1;">{{c.DisplayValue}}</span>
               <span *ngIf="c.Status.ID == -1;">---</span>
              </div>
              <div class="ReceptionProductsCol" style="width: 15%;">
                  <span *ngIf="c.Status.ID == 1;">{{c.Supplier.Name}}</span>
                  <span *ngIf="c.Status.ID == -1;">[ {{c.Status.Name}} ]</span>
              </div>
              <div class="ReceptionProductsCol" style="width: 10%;">
                {{c.PaymentDateUI}}
              </div>
              <div class="ReceptionProductsCol" style="width: 10%;">
                {{c.Value}}
              </div>
              <div class="ReceptionProductsCol" style="width: 10%;">
                {{c.Type.Name}}
              </div>
              <div class="ReceptionProductsCol" style="width: 5%;">
                  {{c.Currency.Name}}
              </div>
              <div class="ReceptionProductsCol" style="width: 5%;">
                  <span *ngIf="c.Currency.ExchangeRate > 0;">{{c.Currency.ExchangeRate}}</span>
                  <span *ngIf="c.Currency.ExchangeRate == 0;">---</span>
                </div>
              <div class="ReceptionProductsCol" style="width: 10%;">
                  {{c.Currency.DecimalPrecision.ID}}
              </div>
              <div class="ReceptionProductsCol" style="width: 20%;">
                  {{c.PaymentExternalID}}
              </div>
              <div class="ReceptionProductsCol" style="width: 10%;" *ngIf="c.ID != 0;">
                  <i class="material-icons ReceptionProductEdit" (click)="OpenSuggestedPaymentModifier(c); ShowSuggestedPaymentModifier = true;">edit</i>
                  <i class="material-icons ReceptionProductEdit" style="color: red;" (click)="ClonePayment(c); ShowDeleteSpendingQuestion = true;">close</i>
              </div>

              <div class="ReceptionProductsCol" style="width: 10%;" *ngIf="c.ID == 0;">
                <i class="material-icons ReceptionProductEdit" style="color: red;" (click)="DeleteNewPaymentOnNewReception(c);">close</i>
            </div>
          </div>
      </div>


  </div>

   </div>

   <div class="PopUpCommands" style="height: auto;min-height: 50px;padding-bottom: 15px;">
      <div *ngIf="this.SuggestedPayments != null && this.SuggestedPayments.length > 0 && !loading;">
          <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngFor="let Total of this.PaymentTotals; let i=index;">
              <div class="ReceptionProductsCol" style="width: 5%;">

              </div>
              <div class="ReceptionProductsCol" style="width: 15%;">
              </div>
              <div class="ReceptionProductsCol" style="width: 10%;text-align: left;padding-left: 1%;">
                  {{this.SuggestedPayments.length}} {{'Payments' | translate}}
              </div>
              <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                  Total:
              </div>
              <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                <p>{{Total.UITotalQtyPriceVAT.Integer}} <span class="DecimalsSpan">{{Total.UITotalQtyPriceVAT.Decimals}}</span></p>
              </div>
              <div class="ReceptionProductsCol totalCol" style="width: 5%;">
                  {{Total.Currency.Name}}
              </div>
              <div class="ReceptionProductsCol totalCol" style="width: 5%;">

              </div>
              <div class="ReceptionProductsCol totalCol" style="width: 10%;">

              </div>
              <div class="ReceptionProductsCol" style="width: 20%;">

              </div>
              <div class="ReceptionProductsCol" style="width: 10%;">

              </div>
          </div>
      </div>
  </div>
</div>

<!-- Delete Box Question Popup - Higher z-index to appear above Shipping Details -->
<div class="PopUpOverlay DeleteBoxOverlay" *ngIf="ShowDeleteBoxQuestion" (click)="ShowDeleteBoxQuestion = false; CurrentBox = null;"></div>

<div class="InfoQuestion DeleteBoxQuestion animated fadeInDown" *ngIf="ShowDeleteBoxQuestion">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowDeleteBoxQuestion = false; CurrentBox = null;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'Configuration.DeleteQuestion' | translate }}
  </div>
  <div class="InfoQuestionBody">
    {{ 'Configuration.DeleteQuestionDescription' | translate }}
  </div>

  <div class="InfoQuestionCommands">
    <button class="ModernButton ModernButtonSecondary" (click)="ShowDeleteBoxQuestion = false; CurrentBox = null;">
      <i class="material-icons">close</i>
      <span>{{ 'Configuration.DeleteNoButton' | translate }}</span>
    </button>
    <button class="ModernButton ModernButtonDanger" (click)="ShowDeleteBoxQuestion = false;DeleteBox(CurrentBox.UIID);">
      <i class="material-icons">delete_forever</i>
      <span>{{ 'Configuration.DeleteYesButton' | translate }}</span>
    </button>
  </div>
</div>

<!-- Import with Indexes Popup - Outside DocumentContainer for full viewport overlay -->
<div class="PopUpOverlay" *ngIf="ShowImportWithIndexesPopup" (click)="ShowImportWithIndexesPopup = false; showCodeIndexDropdown = false; showNameIndexDropdown = false; showQuantityIndexDropdown = false; showPriceIndexDropdown = false; showTotalIndexDropdown = false;"></div>

<div *ngIf="ShowImportWithIndexesPopup" class="animated fadeInDown ImportWithIndexesPopup">
  <div class="PopUpCloseContainer" (click)="ShowImportWithIndexesPopup = false; showCodeIndexDropdown = false; showNameIndexDropdown = false; showQuantityIndexDropdown = false; showPriceIndexDropdown = false; showTotalIndexDropdown = false;">
    <i class="material-icons">close</i>
  </div>

  <div class="PopUpTitleContainer">
    <p>{{ 'ImportReceptionWithIndexes' | translate }}</p>
  </div>

  <div class="PopUpBody">
    <!-- File Upload Section -->
    <div class="ImportIndexesFileSection">
      <p class="NewTextBoxContainerTitle">{{ 'UploadExcelFile' | translate }}</p>

      <input type="file"
             #excelFileInput
             (change)="onSelectExcelFile($event)"
             accept=".xlsx,.xls,.csv"
             style="display: none;">

      <button class="ModernButton ModernButtonSuccess"
              [disabled]="!partner || !currency || !ReceptionPrecision"
              [title]="(!partner || !currency || !ReceptionPrecision) ? 'Please select Partner, Currency and Decimal Precision first' : ''"
              (click)="excelFileInput.click()"
              *ngIf="!selectedExcelFile">
        <i class="material-icons">upload_file</i>
        <span>{{ 'ChooseExcelFile' | translate }}</span>
      </button>

      <div class="FileSelectedDisplay" *ngIf="selectedExcelFile">
        <div class="FileInfo">
          <i class="material-icons">description</i>
          <span class="FileName">{{ selectedExcelFile.name }}</span>
          <span class="FileSize">({{ formatFileSize(selectedExcelFile.size) }})</span>
        </div>
        <button class="ModernButton ModernButtonSecondary" (click)="clearSelectedExcelFile()">
          <i class="material-icons">close</i>
          <span>{{ 'Cancel' | translate }}</span>
        </button>
      </div>
    </div>

    <!-- Column Indexes Configuration -->
    <div class="ImportIndexesConfigSection">
      <p class="IndexGroupTitle">{{ 'ColumnIndexes' | translate }}</p>

      <!-- Code Index -->
      <div>
        <p class="NewTextBoxContainerTitle">{{ 'CodeIndex' | translate }}</p>
        <div class="CustomDropdownContainer">
          <div class="DropdownOverlayTransparent" *ngIf="showCodeIndexDropdown" (click)="showCodeIndexDropdown = false"></div>
          <div class="CustomDropdownBar" [class.open]="showCodeIndexDropdown" (click)="showCodeIndexDropdown = !showCodeIndexDropdown">
            <span class="dropdown-label">{{ 'CodeIndex' | translate }}</span>
            <i class="material-icons dropdown-icon-left">view_column</i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!CurrentReception.ImportIndexes?.Code?.Name" [value]="CurrentReception.ImportIndexes?.Code?.Name || ('CodeIndex' | translate)" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showCodeIndexDropdown">
            <div class="CustomDropdownResult" *ngFor="let p of ConfigurationPositions" [class.selected]="comparePosition(CurrentReception.ImportIndexes?.Code, p)" (click)="CurrentReception.ImportIndexes.Code = p; showCodeIndexDropdown = false;">
              <div class="CustomDropdownResultMain">
                <span class="CustomDropdownResultText">{{p.Name}}</span>
              </div>
              <i class="material-icons CustomDropdownResultCheck" *ngIf="comparePosition(CurrentReception.ImportIndexes?.Code, p)">check</i>
            </div>
          </div>
        </div>
      </div>

      <!-- Name Index -->
      <div>
        <p class="NewTextBoxContainerTitle">{{ 'NameIndex' | translate }}</p>
        <div class="CustomDropdownContainer">
          <div class="DropdownOverlayTransparent" *ngIf="showNameIndexDropdown" (click)="showNameIndexDropdown = false"></div>
          <div class="CustomDropdownBar" [class.open]="showNameIndexDropdown" (click)="showNameIndexDropdown = !showNameIndexDropdown">
            <span class="dropdown-label">{{ 'NameIndex' | translate }}</span>
            <i class="material-icons dropdown-icon-left">view_column</i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!CurrentReception.ImportIndexes?.Name?.Name" [value]="CurrentReception.ImportIndexes?.Name?.Name || ('NameIndex' | translate)" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showNameIndexDropdown">
            <div class="CustomDropdownResult" *ngFor="let p of ConfigurationPositions" [class.selected]="comparePosition(CurrentReception.ImportIndexes?.Name, p)" (click)="CurrentReception.ImportIndexes.Name = p; showNameIndexDropdown = false;">
              <div class="CustomDropdownResultMain">
                <span class="CustomDropdownResultText">{{p.Name}}</span>
              </div>
              <i class="material-icons CustomDropdownResultCheck" *ngIf="comparePosition(CurrentReception.ImportIndexes?.Name, p)">check</i>
            </div>
          </div>
        </div>
      </div>

      <!-- Quantity Index -->
      <div>
        <p class="NewTextBoxContainerTitle">{{ 'QuantityIndex' | translate }}</p>
        <div class="CustomDropdownContainer">
          <div class="DropdownOverlayTransparent" *ngIf="showQuantityIndexDropdown" (click)="showQuantityIndexDropdown = false"></div>
          <div class="CustomDropdownBar" [class.open]="showQuantityIndexDropdown" (click)="showQuantityIndexDropdown = !showQuantityIndexDropdown">
            <span class="dropdown-label">{{ 'QuantityIndex' | translate }}</span>
            <i class="material-icons dropdown-icon-left">view_column</i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!CurrentReception.ImportIndexes?.Quantity?.Name" [value]="CurrentReception.ImportIndexes?.Quantity?.Name || ('QuantityIndex' | translate)" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showQuantityIndexDropdown">
            <div class="CustomDropdownResult" *ngFor="let p of ConfigurationPositions" [class.selected]="comparePosition(CurrentReception.ImportIndexes?.Quantity, p)" (click)="CurrentReception.ImportIndexes.Quantity = p; showQuantityIndexDropdown = false;">
              <div class="CustomDropdownResultMain">
                <span class="CustomDropdownResultText">{{p.Name}}</span>
              </div>
              <i class="material-icons CustomDropdownResultCheck" *ngIf="comparePosition(CurrentReception.ImportIndexes?.Quantity, p)">check</i>
            </div>
          </div>
        </div>
      </div>

      <!-- Price Index -->
      <div>
        <p class="NewTextBoxContainerTitle">{{ 'PriceIndex' | translate }}</p>
        <div class="CustomDropdownContainer">
          <div class="DropdownOverlayTransparent" *ngIf="showPriceIndexDropdown" (click)="showPriceIndexDropdown = false"></div>
          <div class="CustomDropdownBar" [class.open]="showPriceIndexDropdown" (click)="showPriceIndexDropdown = !showPriceIndexDropdown">
            <span class="dropdown-label">{{ 'PriceIndex' | translate }}</span>
            <i class="material-icons dropdown-icon-left">view_column</i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!CurrentReception.ImportIndexes?.Price?.Name" [value]="CurrentReception.ImportIndexes?.Price?.Name || ('PriceIndex' | translate)" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showPriceIndexDropdown">
            <div class="CustomDropdownResult" *ngFor="let p of ConfigurationPositions" [class.selected]="comparePosition(CurrentReception.ImportIndexes?.Price, p)" (click)="CurrentReception.ImportIndexes.Price = p; showPriceIndexDropdown = false;">
              <div class="CustomDropdownResultMain">
                <span class="CustomDropdownResultText">{{p.Name}}</span>
              </div>
              <i class="material-icons CustomDropdownResultCheck" *ngIf="comparePosition(CurrentReception.ImportIndexes?.Price, p)">check</i>
            </div>
          </div>
        </div>
      </div>

      <!-- Total Index -->
      <div>
        <p class="NewTextBoxContainerTitle">{{ 'TotalIndex' | translate }}</p>
        <div class="CustomDropdownContainer">
          <div class="DropdownOverlayTransparent" *ngIf="showTotalIndexDropdown" (click)="showTotalIndexDropdown = false"></div>
          <div class="CustomDropdownBar" [class.open]="showTotalIndexDropdown" (click)="showTotalIndexDropdown = !showTotalIndexDropdown">
            <span class="dropdown-label">{{ 'TotalIndex' | translate }}</span>
            <i class="material-icons dropdown-icon-left">view_column</i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!CurrentReception.ImportIndexes?.Total?.Name" [value]="CurrentReception.ImportIndexes?.Total?.Name || ('TotalIndex' | translate)" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showTotalIndexDropdown">
            <div class="CustomDropdownResult" *ngFor="let p of ConfigurationPositions" [class.selected]="comparePosition(CurrentReception.ImportIndexes?.Total, p)" (click)="CurrentReception.ImportIndexes.Total = p; showTotalIndexDropdown = false;">
              <div class="CustomDropdownResultMain">
                <span class="CustomDropdownResultText">{{p.Name}}</span>
              </div>
              <i class="material-icons CustomDropdownResultCheck" *ngIf="comparePosition(CurrentReception.ImportIndexes?.Total, p)">check</i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="PopUpCommands">
    <button [disabled]="!selectedExcelFile || parent.loading"
            class="ModernButton ModernButtonPrimary"
            (click)="ImportReceptionWithIndexes();">
      <i class="material-icons">cloud_upload</i>
      <span>{{ 'ImportReception' | translate }}</span>
    </button>
  </div>
</div>

<!-- Overlays - positioned outside MainContainer for full viewport coverage -->
<div class="overlay" *ngIf="ShowNoDocumentNumberError || ShowDetectedPaymentsContainer || ShowShippingDetailsContainer || ShowDeleteBoxQuestion || ShowSuggestedPaymentModifier || ShowSuggestionPaymentsContainer || ShowPaymentContainer || DeleteFileQuestion || ShowDocumentError || ShowProductTaxDivisionContainer || showProductDiscountContainer || showAddNewPartnerPopUp || showEditPartnerPopUp || ShowReceptionEditProductContainer || this.parent.loading  || this.parent.initialLoad || showDocumentDiscountContainer || showReceptionVisualizer || ShowImportWithIndexesPopup;"></div>
<div class="overlay" *ngIf="showAccountingSeriesError;" (click)="this.parent.RedirectToURL('/dashboard/settings/mycompany');"></div>
<div class="PopUpOverlay" *ngIf="ShowPaymentContainer"></div>

<!-- InfoQuestion for accounting series error - positioned outside MainContainer -->
<div class="InfoQuestion animated fadeInDown" *ngIf="showAccountingSeriesError">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="this.parent.RedirectToURL('/dashboard/settings/mycompany');">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'Configuration.AccountingSeriesDocumentError' | translate }}
  </div>
  <div class="InfoQuestionBody">
    {{ 'Configuration.AccountingSeriesDocumentErrorDescription' | translate }}
  </div>

  <div class="InfoQuestionCommands">
    <button mat-raised-button color="primary" class="InfoQuestionButton" (click)="this.parent.RedirectToURL('/dashboard/settings/mycompany');"> {{ 'Configuration.GoToSettings' | translate }}</button>
  </div>
</div>

<!-- Payment Container Popup - positioned outside MainContainer -->
<div class="animated fadeInDown CashCollectionContainer" *ngIf="ShowPaymentContainer">
  <div class="PopUpCloseContainer" (click)="ShowPaymentContainer = false;">
    <i class="material-icons">close</i>
  </div>

  <div class="PopUpTitleContainer">
    <p *ngIf="this.currentPayment.ID > 0;">{{ 'UpdatePayment' | translate }}</p>
    <p *ngIf="!this.currentPayment.ID > 0;">{{ 'NewPayment' | translate }}</p>
   </div>

   <div class="PopUpBody" style="margin-top: 20px;">

      <p class="NewTextBoxContainerTitle">{{ 'PaymentType' | translate }}</p>
      <div class="CustomDropdownContainer">
        <div class="DropdownOverlayTransparent" *ngIf="showPaymentTypeDropdown" (click)="showPaymentTypeDropdown = false"></div>
        <div class="CustomDropdownBar" [class.open]="showPaymentTypeDropdown" (click)="showPaymentTypeDropdown = !showPaymentTypeDropdown">
          <span class="dropdown-label">{{ 'PaymentType' | translate }}</span>
          <i class="material-icons dropdown-icon-left">payment</i>
          <input type="text" class="CustomDropdownInput" [class.placeholder]="!currentPayment.Type?.Name" [value]="currentPayment.Type?.Name || ('PaymentType' | translate)" readonly />
          <i class="material-icons dropdown-icon">arrow_drop_down</i>
        </div>
        <div class="CustomDropdownResults" *ngIf="showPaymentTypeDropdown">
          <div class="CustomDropdownResult" *ngFor="let type of this.PaymentTypes;" [class.selected]="compareFn(currentPayment.Type, type)" (click)="currentPayment.Type = type; showPaymentTypeDropdown = false;">
            <div class="CustomDropdownResultMain">
              <span class="CustomDropdownResultText">{{type.Name}}</span>
            </div>
            <i class="material-icons CustomDropdownResultCheck" *ngIf="compareFn(currentPayment.Type, type)">check</i>
          </div>
        </div>
      </div>

      <p class="NewTextBoxContainerTitle">{{ 'Currency' | translate }}</p>
      <div class="CustomDropdownContainer">
        <div class="DropdownOverlayTransparent" *ngIf="showPaymentCurrencyDropdown" (click)="showPaymentCurrencyDropdown = false"></div>
        <div class="CustomDropdownBar" [class.open]="showPaymentCurrencyDropdown" (click)="showPaymentCurrencyDropdown = !showPaymentCurrencyDropdown">
          <span class="dropdown-label">{{ 'Currency' | translate }}</span>
          <i class="material-icons dropdown-icon-left">attach_money</i>
          <input type="text" class="CustomDropdownInput" [class.placeholder]="!currentPayment.Currency?.Name" [value]="currentPayment.Currency?.Name || ('Currency' | translate)" readonly />
          <i class="material-icons dropdown-icon">arrow_drop_down</i>
        </div>
        <div class="CustomDropdownResults" *ngIf="showPaymentCurrencyDropdown">
          <div class="CustomDropdownResult" *ngFor="let c of this.Currencies;" [class.selected]="compareFn(currentPayment.Currency, c)" (click)="currentPayment.Currency = c; ReselectBankAccount(c); showPaymentCurrencyDropdown = false;">
            <div class="CustomDropdownResultMain">
              <span class="CustomDropdownResultText">{{c.Name}}</span>
            </div>
            <i class="material-icons CustomDropdownResultCheck" *ngIf="compareFn(currentPayment.Currency, c)">check</i>
          </div>
        </div>
      </div>

      <p class="NewTextBoxContainerTitle">{{ 'AccountNumber' | translate }}</p>
      <div class="CustomDropdownContainer">
        <div class="DropdownOverlayTransparent" *ngIf="showPaymentBankAccountDropdown" (click)="showPaymentBankAccountDropdown = false"></div>
        <div class="CustomDropdownBar" [class.open]="showPaymentBankAccountDropdown" (click)="showPaymentBankAccountDropdown = !showPaymentBankAccountDropdown">
          <span class="dropdown-label">{{ 'AccountNumber' | translate }}</span>
          <i class="material-icons dropdown-icon-left">account_balance</i>
          <input type="text" class="CustomDropdownInput" [class.placeholder]="!currentPayment.BankAccount?.DisplayValue" [value]="currentPayment.BankAccount?.DisplayValue || ('AccountNumber' | translate)" readonly />
          <i class="material-icons dropdown-icon">arrow_drop_down</i>
        </div>
        <div class="CustomDropdownResults" *ngIf="showPaymentBankAccountDropdown">
          <div class="CustomDropdownResult" *ngFor="let b of this.BankAccounts;" [class.selected]="compareFn(currentPayment.BankAccount, b)" (click)="currentPayment.BankAccount = b; showPaymentBankAccountDropdown = false;">
            <div class="CustomDropdownResultMain">
              <span class="CustomDropdownResultText">{{b.DisplayValue}}</span>
            </div>
            <i class="material-icons CustomDropdownResultCheck" *ngIf="compareFn(currentPayment.BankAccount, b)">check</i>
          </div>
        </div>
      </div>

      <div *ngIf="this.currentPayment.Currency.ExchangeRate > 0;">
        <p class="NewTextBoxContainerTitle">{{ 'Receptions.ExchangeRate' | translate }}</p>
        <div class="NewTextBoxContainer">
          <i class="material-icons" style="color: #4a7bb8;">calculate</i>
          <input type="text" class="NewTextBox" placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.Currency.ExchangeRate">
        </div>
      </div>

      <p class="NewTextBoxContainerTitle">{{ 'Receptions.DecimalPercision' | translate }}</p>
      <div class="CustomDropdownContainer">
        <div class="DropdownOverlayTransparent" *ngIf="showPaymentDecimalPrecisionDropdown" (click)="showPaymentDecimalPrecisionDropdown = false"></div>
        <div class="CustomDropdownBar" [class.open]="showPaymentDecimalPrecisionDropdown" (click)="showPaymentDecimalPrecisionDropdown = !showPaymentDecimalPrecisionDropdown">
          <span class="dropdown-label">{{ 'Receptions.DecimalPercision' | translate }}</span>
          <i class="material-icons dropdown-icon-left">calculate</i>
          <input type="text" class="CustomDropdownInput" [class.placeholder]="!currentPayment.Currency.DecimalPrecision?.Meaning" [value]="currentPayment.Currency.DecimalPrecision?.Meaning || ('Receptions.DecimalPercision' | translate)" readonly />
          <i class="material-icons dropdown-icon">arrow_drop_down</i>
        </div>
        <div class="CustomDropdownResults" *ngIf="showPaymentDecimalPrecisionDropdown">
          <div class="CustomDropdownResult" *ngFor="let d of this.DecimalPrecisions;" [class.selected]="compareFn(currentPayment.Currency.DecimalPrecision, d)" (click)="currentPayment.Currency.DecimalPrecision = d; showPaymentDecimalPrecisionDropdown = false;">
            <div class="CustomDropdownResultMain">
              <span class="CustomDropdownResultText">{{d.Meaning}}</span>
            </div>
            <i class="material-icons CustomDropdownResultCheck" *ngIf="compareFn(currentPayment.Currency.DecimalPrecision, d)">check</i>
          </div>
        </div>
      </div>

      <p class="NewTextBoxContainerTitle">{{ 'PaymentDate' | translate }}</p>
      <div class="NewTextBoxContainer">
        <input type="text" class="NewTextBox" [matDatepicker]="dp3" [formControl]="CollectionDate" [(ngModel)]="currentPayment.PaymentDate">
        <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
        <mat-datepicker #dp3></mat-datepicker>
      </div>

      <p class="NewTextBoxContainerTitle">{{ 'PaymentValue' | translate }}* [{{this.currentPayment.Currency.Name}}]</p>
      <div class="NewTextBoxContainer">
        <i class="material-icons" style="color: #32aa3a;">monetization_on</i>
        <input type="text" class="NewTextBox" placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.Value" style="color: #32aa3a;" (change)="VerifyPriceModel(this.currentPayment.Value);">
      </div>

      <p class="NewTextBoxContainerTitle">{{ 'PaymentExternalID' | translate }}</p>
      <div class="NewTextBoxContainer">
        <i class="material-icons" style="color: #4a7bb8;">qr_code_2</i>
        <input type="text" class="NewTextBox" placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.PaymentExternalID">
      </div>

      <p class="CashCollectRemainingInfo" *ngIf="this.PaymentRemainingValue >= 0;">{{'RemainingToPay' | translate}}: {{this.PaymentRemainingValue}} {{this.currentPayment.Currency.Name}}</p>
      <p class="CashCollectRemainingInfo" *ngIf="this.PaymentRemainingValue < 0;">{{'OverPayed' | translate}}: {{this.PaymentRemainingValue}} {{this.currentPayment.Currency.Name}}</p>
   </div>

   <div class="PopUpCommands">
      <button *ngIf="!this.currentPayment.ID > 0;" [disabled]="parent.loading" class="ModernButton ModernButtonPrimary" matTooltip="Submit Cash Collection" (click)="AddPayment();ShowPaymentContainer = false;">
        <i class="material-icons">add</i>
        <span>{{'AddPayment' | translate}}</span>
      </button>
  </div>
</div>